import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import { SITENAMEALIAS, LOGO, WEBSERVICE, isTestMode } from "../utils/init";
import Moment from "react-moment";
import { Link, useHistory } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import {
  showToast,
  showHttpError,
  formatAmount,
  currentPageAccess,
  handleCurrencyDetiails,
  handleDynamicCurrencyDetiails,
} from "../utils/library";
import {
  FetchMerchantStatus,
  FetchPerDayTotalBTCTracsaction,
  FetchUsdBtcLedgerAmount,
  FetchPerDaySuccessUnsuccessTransacCount,
  FetchTotalAverageSale,
  SendToOther,
  CheckMfaStatus,
  GetUserBankDetails,
  GetUserDetails,
  GetTransactionLimitByTier,
  ConvertPrice,
  CreateWithdrawalRequest,
  getCryptoAddress,
  getAuthToken,
  getAuthUuid,
} from "../utils/service";
import BtcLogo from "../assets/images/currency/BTC.svg";
import EthLogo from "../assets/images/currency/ETH.svg";
import LtcLogo from "../assets/images/currency/LTC.svg";
import btcLogo from "../assets/images/currency/BTC.svg";
import BchLogo from "../assets/images/currency/BCH.svg";
import { RangeDatePicker } from "react-google-flight-datepicker";
import "react-google-flight-datepicker/dist/main.css";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { Modal } from "react-bootstrap";
import { CAPTCHASITEKEY, PAYBITOCAPTCHASITEKEY } from "../utils/init";
import ReCAPTCHA from "react-google-recaptcha";
import { CaptchaVerify } from "../utils/service";
import PaybitoCaptchaExchange from "../components/PaybitoCaptchaExchange";
import {
  ipgeolocation,
  paybitoLogin,
  paybitoSentOtp,
  paybitoSentOtpForLogin,
  paybitoSignUp,
  paybitoResetPassword,
  checkBroker,
  transferBalencetoPaybito,
  paybitoForgotPassword,
  ResendOTP,
  checkTwoFactorLogin,
  CheckOTP,
  isCryptoAddrValid,
  getFeesByCurrencyId,
  GetUserTransaction,
  MerchantForgotPassword,
  userAccountStatus,
  getFees,
  paybitoLoginMobileOtp,
  coinSendToOther,
  FetchUserSettings,
} from "../utils/service";
import uuid from "react-uuid";
import {
  isBrowser,
  isMobile,
  browserName,
  browserVersion,
} from "react-device-detect";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import qs from "qs";
import CaptchaModal from "./CaptchaModal";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const styles = {
  pageWrapper: { padding: "36px 24px 60px" },
  card: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid var(--body-color-less2)",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    padding: "28px 32px",
    marginBottom: "28px",
  },
  cardHeaderRow: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    marginBottom: "24px",
  },
  cardHeaderIcon: {
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    color: "var(--btn-color)",
    flexShrink: 0,
  },
  iconBlue: {
    background:
      "linear-gradient(135deg, color-mix(in srgb, var(--btn-color) 15%, transparent), color-mix(in srgb, var(--btn-color) 5%, transparent))",
  },
  iconPurple: {
    background:
      "linear-gradient(135deg, color-mix(in srgb, #8b5cf6 15%, transparent), color-mix(in srgb, #8b5cf6 5%, transparent))",
    color: "#8b5cf6",
  },
  iconGreen: {
    background:
      "linear-gradient(135deg, color-mix(in srgb, #10b981 15%, transparent), color-mix(in srgb, #10b981 5%, transparent))",
    color: "#10b981",
  },
  iconAmber: {
    background:
      "linear-gradient(135deg, color-mix(in srgb, #f59e0b 15%, transparent), color-mix(in srgb, #f59e0b 5%, transparent))",
    color: "#f59e0b",
  },
  iconRed: {
    background:
      "linear-gradient(135deg, color-mix(in srgb, #ef4444 15%, transparent), color-mix(in srgb, #ef4444 5%, transparent))",
    color: "#ef4444",
  },
  cardTitle: {
    fontSize: "17px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
    letterSpacing: "-0.2px",
  },
  cardSubtitle: { fontSize: "12px", opacity: 0.5, marginTop: "2px" },
  table: { width: "100%", borderCollapse: "separate", borderSpacing: "0 0" },
  th: {
    padding: "12px 18px",
    fontSize: "11px",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "0.8px",
    color: "#8b5cf6",
    background:
      "linear-gradient(135deg, color-mix(in srgb, #8b5cf6 6%, transparent), color-mix(in srgb, #8b5cf6 2%, transparent))",
    borderBottom: "2px solid color-mix(in srgb, #8b5cf6 15%, transparent)",
    whiteSpace: "nowrap",
  },
  td: {
    padding: "16px 18px",
    fontSize: "14px",
    color: "var(--text-color)",
    borderBottom:
      "1px solid color-mix(in srgb, var(--body-color-less2) 60%, transparent)",
    verticalAlign: "middle",
    transition: "background 0.2s ease",
  },
  assetRow: { display: "flex", alignItems: "center", gap: "12px" },
  assetIcon: { width: "32px", height: "32px", borderRadius: "50%" },
  assetName: { fontWeight: "600", fontSize: "14px" },
  assetCode: { fontSize: "12px", opacity: 0.5 },
  balanceText: {
    fontFamily: "'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace",
    fontWeight: "600",
    fontSize: "14px",
  },
  btnPrimary: {
    padding: "9px 24px",
    background: "var(--btn-color)",
    color: "#fff",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    border: "none",
    cursor: "pointer",
    transition: "opacity 0.2s",
  },
  btnSecondary: {
    padding: "9px 24px",
    background: "transparent",
    color: "var(--text-color)",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    border: "1px solid var(--body-color-less2)",
    cursor: "pointer",
    transition: "opacity 0.2s",
  },
  btnOutline: {
    padding: "9px 24px",
    background: "transparent",
    color: "var(--btn-color)",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    border: "1px solid var(--btn-color)",
    cursor: "pointer",
  },
  btnDanger: {
    padding: "9px 24px",
    background:
      "linear-gradient(135deg, color-mix(in srgb, #ef4444 12%, transparent), color-mix(in srgb, #ef4444 4%, transparent))",
    color: "#ef4444",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    border: "1px solid color-mix(in srgb, #ef4444 20%, transparent)",
    cursor: "pointer",
  },
  btnSuccess: {
    padding: "9px 24px",
    background:
      "linear-gradient(135deg, color-mix(in srgb, #10b981 12%, transparent), color-mix(in srgb, #10b981 4%, transparent))",
    color: "#10b981",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    border: "1px solid color-mix(in srgb, #10b981 20%, transparent)",
    cursor: "pointer",
  },
  input: {
    width: "100%",
    padding: "10px 14px",
    fontSize: "14px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    outline: "none",
    transition: "border-color 0.2s",
  },
  label: {
    display: "block",
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "0.3px",
    opacity: 0.7,
    color: "var(--text-color)",
    marginBottom: "6px",
  },
  formGroup: { marginBottom: "18px" },
  statusBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "5px 14px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "600",
    lineHeight: "1.4",
    letterSpacing: "0.3px",
  },
  statusDot: {
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    display: "inline-block",
  },
  statusPending: {
    background:
      "linear-gradient(135deg, color-mix(in srgb, #f59e0b 15%, transparent), color-mix(in srgb, #f59e0b 8%, transparent))",
    color: "#f59e0b",
    border: "1px solid color-mix(in srgb, #f59e0b 25%, transparent)",
  },
  statusConfirmed: {
    background:
      "linear-gradient(135deg, color-mix(in srgb, #10b981 15%, transparent), color-mix(in srgb, #10b981 8%, transparent))",
    color: "#10b981",
    border: "1px solid color-mix(in srgb, #10b981 25%, transparent)",
  },
  statusFailed: {
    background:
      "linear-gradient(135deg, color-mix(in srgb, #ef4444 15%, transparent), color-mix(in srgb, #ef4444 8%, transparent))",
    color: "#ef4444",
    border: "1px solid color-mix(in srgb, #ef4444 25%, transparent)",
  },
  paginationBtn: {
    padding: "8px 16px",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    border: "1px solid var(--body-color-less2)",
    background: "transparent",
    color: "var(--text-color)",
    cursor: "pointer",
    minWidth: "40px",
    textAlign: "center",
    transition: "all 0.2s ease",
  },
  paginationActive: {
    background: "linear-gradient(135deg, #8b5cf6, #7c3aed)",
    color: "#fff",
    border: "1px solid #8b5cf6",
    boxShadow: "0 4px 12px color-mix(in srgb, #8b5cf6 30%, transparent)",
  },
  emptyState: {
    textAlign: "center",
    padding: "60px 24px",
    opacity: 0.6,
  },
  emptyIcon: {
    fontSize: "48px",
    marginBottom: "16px",
    opacity: 0.4,
    background: "linear-gradient(135deg, #8b5cf6, #a78bfa)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  modalOverlay: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid var(--body-color-less2)",
    overflow: "hidden",
  },
  modalHeader: {
    padding: "24px 28px 0",
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  modalTitle: {
    fontSize: "17px",
    fontWeight: "700",
    color: "var(--text-color)",
  },
  modalBody: { padding: "20px 28px 28px" },
  modalFooter: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginTop: "20px",
  },
  withdrawOption: {
    padding: "18px 20px",
    borderRadius: "12px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    cursor: "pointer",
    textAlign: "center",
    fontWeight: "600",
    fontSize: "14px",
    color: "var(--text-color)",
    transition: "border-color 0.2s, box-shadow 0.2s",
    marginBottom: "12px",
  },
  withdrawDivider: {
    textAlign: "center",
    fontSize: "12px",
    fontWeight: "600",
    opacity: 0.4,
    margin: "4px 0",
    textTransform: "uppercase",
    letterSpacing: "1px",
  },
  networkOption: {
    padding: "14px 20px",
    borderRadius: "12px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    cursor: "pointer",
    textAlign: "center",
    fontWeight: "600",
    fontSize: "14px",
    color: "var(--text-color)",
    marginBottom: "10px",
    transition: "border-color 0.2s",
  },
  infoBox: {
    padding: "14px 18px",
    borderRadius: "10px",
    background: "color-mix(in srgb, var(--btn-color) 8%, transparent)",
    border: "1px solid color-mix(in srgb, var(--btn-color) 20%, transparent)",
    fontSize: "13px",
    color: "var(--text-color)",
  },
  warningBox: {
    padding: "14px 18px",
    borderRadius: "10px",
    background: "color-mix(in srgb, #f59e0b 8%, transparent)",
    border: "1px solid color-mix(in srgb, #f59e0b 20%, transparent)",
    fontSize: "13px",
    color: "var(--text-color)",
  },
  bankDetailRow: {
    display: "flex",
    padding: "8px 0",
    borderBottom: "1px solid var(--body-color-less2)",
    fontSize: "13px",
  },
  bankDetailLabel: { width: "40%", opacity: 0.6, fontWeight: "500" },
  bankDetailValue: { width: "60%", fontWeight: "600" },
  timerText: {
    fontSize: "12px",
    color: "var(--btn-color)",
    fontWeight: "600",
    marginTop: "6px",
  },
  getCodeBtn: {
    position: "absolute",
    right: "14px",
    top: "50%",
    transform: "translateY(-50%)",
    background: "none",
    border: "none",
    color: "var(--btn-color)",
    fontWeight: "600",
    fontSize: "13px",
    cursor: "pointer",
  },
  linkText: {
    color: "var(--btn-color)",
    cursor: "pointer",
    fontWeight: "500",
    textDecoration: "none",
    fontSize: "13px",
  },
  inputGroupAppend: {
    position: "absolute",
    right: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    cursor: "pointer",
    opacity: 0.5,
  },
  passwordHint: {
    fontSize: "11px",
    color: "#ef4444",
    marginTop: "6px",
    lineHeight: "1.4",
  },
  matchText: { fontSize: "12px", fontWeight: "600", marginTop: "4px" },
  radioGroup: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
    marginBottom: "16px",
  },
  radioLabel: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "13px",
    cursor: "pointer",
    color: "var(--text-color)",
  },
  select: {
    width: "100%",
    padding: "10px 14px",
    fontSize: "14px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    outline: "none",
    cursor: "pointer",
  },
};

const Dashboard = () => {
  const history = useHistory();

  // State declarations
  const [theme, setTheme] = useState(
    localStorage.getItem(SITENAMEALIAS + "_theme") || "dark"
  );
  const [homeCurrency, setHomeCurrency] = useState(
    localStorage.getItem(SITENAMEALIAS + "_home_currency") || "USD"
  );
  const [showAddAddressModal, setShowAddAddressModal] = useState(false);
  const [showCaptchaModal, setShowCaptchaModal] = useState(false);
  const [showCaptchaModalThird, setShowCaptchaModalThird] = useState(false);
  const [showCaptchaModalSecond, setShowCaptchaModalSecond] = useState(false);
  const [showPaybitoLoginCaptcha, setShowPaybitoLoginCaptcha] = useState(true);
  const [showPaybitoSignupCaptcha, setShowPaybitoSignupCaptcha] =
    useState(false);
  const [showPaybitoOtpModal, setShowPaybitoOtpModal] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [showNetworkPopup, setShowNetworkPopup] = useState(false);
  const [brokerIdInfoModal, setBrokerIdInfoModal] = useState(false);
  const [paybitoForgetPswdModal, setPaybitoForgetPswdModal] = useState(false);
  const [showPaybitoSecurityAuthModal, setShowPaybitoSecurityAuthModal] =
    useState(false);
  const [paybitoResetPswdModal, setPaybitoResetPswdModal] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [phoneErrorMsg, setPhoneErrorMsg] = useState(false);
  const [passwordType, setPasswordType] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [assets, setAssets] = useState([]);
  const [cryptoIdForTransfer, setCryptoIdForTransfer] = useState("");
  const [cryptoNameForTransfer, setCryptoNameForTransfer] = useState("");
  const [pageNo, setPageNo] = useState("1");
  const [noOfItemsPerPage, setNoOfItemsPerPage] = useState("20");
  const [totalCount, setTotalCount] = useState(0);
  const [userTransactionList, setUserTransactionList] = useState([]);
  const [pageList, setPageList] = useState([]);
  const [selectedAsset, setSelectedAsset] = useState({});
  const [selectedAssetForWithdraw, setSelectedAssetForWithdraw] = useState({});
  const [isLoggedInToExchange, setIsLoggedInToExchange] = useState(false);
  const [totalSalesVolume, setTotalSalesVolume] = useState("0.00");
  const [averageSalesAmount, setAverageSalesAmount] = useState("0.00");
  const [isPasswordMatched, setIsPasswordMatched] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [showWithdrawOptionModal, setShowWithdrawOptionModal] = useState(false);
  const [transferModal, setTransferModal] = useState(false);
  const [paybitoSignUpId, setPaybitoSignUpId] = useState("");
  const [isTimerStartForPaybitoGetCode, setIsTimerStartForPaybitoGetCode] =
    useState(false);
  const [
    isTimerStartForExternalWalletGetCode,
    setIsTimerStartForExternalWalletGetCode,
  ] = useState(false);
  const [isTimerStartForSmsGetCode, setIsTimerStartForSmsGetCode] =
    useState(false);
  const [isResendOtpTimerStart, setIsResendOtpTimerStart] = useState(false);
  const [isResendPhoneOtpTimerStart, setIsResendPhoneOtpTimerStart] =
    useState(false);
  const [
    amountForTransferToExternalAddress,
    setAmountForTransferToExternalAddress,
  ] = useState(0);
  const [minLimitForTransfer, setMinLimitForTransfer] = useState(0);
  const [maxLimitForTransfer, setMaxLimitForTransfer] = useState(0);
  const [permission, setPermission] = useState("");

  const [amount, setAmount] = useState("");
  const [amountErrorWallet, setAmountErrorWallet] = useState("");
  const [amountErrorBank, setAmountErrorBank] = useState("");

  const [
    showPaybitoSecurityAuthTranscationModal,
    setShowPaybitoSecurityAuthTranscationModal,
  ] = useState(false);
  const [
    paybitoGoogleAuthTranscationOtpRef,
    setPaybitoGoogleAuthTranscationOtpRef,
  ] = useState("");
  const [signUppage, setSignUppage] = useState(
    localStorage.getItem(SITENAMEALIAS + "_brokerDomain") + "/signup"
  );

  const [options] = useState({
    responsive: true,
    scales: {
      x: { grid: { display: false } },
      y: { grid: { display: false } },
    },
    plugins: { legend: { position: "false" } },
  });

  const [data, setData] = useState({
    labels: [],
    datasets: [
      {
        id: 1,
        label: "",
        data: [],
        backgroundColor: "#004beb",
        borderColor: "#004beb",
      },
    ],
  });

  const [volumeData, setVolumeData] = useState({
    labels: [],
    datasets: [
      {
        id: 1,
        label: "Successful",
        data: [],
        backgroundColor: "#004beb",
        borderColor: "#004beb",
      },
      {
        id: 2,
        label: "Unsuccessful",
        data: [],
        backgroundColor: "#004beb",
        borderColor: "#004beb",
      },
    ],
  });

  const [selectionRangeForDateRange, setSelectionRangeForDateRange] = useState({
    startDate: "",
    endDate: "",
    key: "selection",
  });

  const [paybitoemail, setPaybitoemail] = useState("");
  const [paybitopswd, setPaybitopswd] = useState("");
  const [showOtpTxt, setShowOtpTxt] = useState(true);
  const [paybitoRecaptchaResponse, setPaybitoRecaptchaResponse] = useState("");
  const [paybitoSignupRecaptchResponse, setPaybitoSignupRecaptchResponse] =
    useState("");
  const [paybitoResetPswdCaptchResponse, setPaybitoResetPswdCaptchResponse] =
    useState("");
  const [paybitoOtp, setPaybitoOtp] = useState("");
  const [paybitoMobileAuthOtp, setPaybitoMobileAuthOtp] = useState("");
  const [timer, setTimer] = useState("");
  const [isButtonDisable, setIsButtonDisable] = useState(false);
  const [isExternalTransferSecurityBtn, setIsExternalTransferSecurityBtn] =
    useState(true);
  const [coinIdForTag, setCoinIdForTag] = useState("");
  const [coinTagValue, setCoinTagValue] = useState("");
  const [transferCurrencyName, setTransferCurrencyName] = useState("");
  const [minFee, setMinFee] = useState("");
  const [fromFee, setFromFee] = useState("");
  const [toFee, setToFee] = useState("");
  const [maxAmountSend, setMaxAmountSend] = useState("");
  const [coinBalanceAmt, setCoinBalanceAmt] = useState("");
  const [transferAmtBtn, setTransferAmtBtn] = useState(true);
  const [addressValid, setAddressValid] = useState(true);
  const [feeRate, setFeeRate] = useState("");
  const [currencyPrecision, setCurrencyPrecision] = useState("");
  const [networkFee, setNetworkFee] = useState("");
  const [transferMaxAmount, setTransferMaxAmount] = useState(0);
  const [network, setNetwork] = useState("");
  const [pswdnotmatched, setPswdnotmatched] = useState(false);
  const [amtTransferBtn, setAmtTransferBtn] = useState(true);
  const [changePswd, setChangePswd] = useState(true);
  const [secondStatusCheck, setSecondStatusCheck] = useState(false);
  const [isSecondStatusCheck, setIsSecondStatusCheck] = useState(false);
  const [isSecondStatusMobileCheck, setIsSecondStatusMobileCheck] =
    useState(false);
  const [resendOtpTimerTxt, setResendOtpTimerTxt] = useState("");
  const [resendPhoneOtpTimerTxt, setResendPhoneOtpTimerTxt] = useState("");
  const [resendOtpSecondStatus, setResendOtpSecondStatus] = useState(false);
  const [resendOtpBtn, setResendOtpBtn] = useState(false);
  const [isConfirmBtn, setIsConfirmBtn] = useState(true);
  const [showPaybitoMobileSmsAuthModal, setShowPaybitoMobileSmsAuthModal] =
    useState(false);
  const [showExternalWalletAuthModal, setShowExternalWalletAuthModal] =
    useState(false);
  const [externalWalletEmailAuthOtp, setExternalWalletEmailAuthOtp] =
    useState("");
  const [externalWalletGoogleAuthCode, setExternalWalletGoogleAuthCode] =
    useState("");
  const [externalAddress, setExternalAddress] = useState("");
  const [externalWalletCoinTag, setExternalWalletCoinTag] = useState("");
  const [getCodeTimer, setGetCodeTimer] = useState("");
  const [smsAuthOtp, setSmsAuthOtp] = useState("");
  const [getCodeSmsTimer, setGetCodeSmsTimer] = useState("");
  const [isValidCryptoAddr, setIsValidCryptoAddr] = useState(false);
  const [eye, setEye] = useState(true);
  const [password, setPassword] = useState("password");
  const [type, setType] = useState(false);
  const [isValidCryptoMsg, setIsValidCryptoMsg] = useState("");
  const [classForValidCrypto, setClassForValidCrypto] = useState("");
  const [isTwoFactorAuthOn, setIsTwoFactorAuthOn] = useState(false);
  const [isPhoneValidationOn, setIsPhoneValidationOn] = useState(false);
  const [paybitoEmailOtp, setPaybitoEmailOtp] = useState("");
  const [paybitoGoogleAuthOtp, setPaybitoGoogleAuthOtp] = useState("");
  const [signupPhoneNumberRef, setSignupPhoneNumberRef] = useState(null);
  const [signupCountryCodeRef, setSignupCountryCodeRef] = useState(null);
  const [selectedAssetNetworkList, setSelectedAssetNetworkList] = useState([]);
  const [selectedNetworkForTransfer, setSelectedNetworkForTransfer] =
    useState(null);
  const [merchantBankDetails, setMerchantBankDetails] = useState(null);
  const [showBankTransferModal, setShowBankTransferModal] = useState(false);
  const [cryptoAmountForBank, setCryptoAmountForBank] = useState("");
  const [fiatEquivalentAmount, setFiatEquivalentAmount] = useState("");
  const [googleAuthOtpForBankWithdraw, setGoogleAuthOtpForBankWithdraw] =
    useState("");
  const [bankDetailsStatus, setBankDetailsStatus] = useState(null);
  const [userDocsStatus, setUserDocsStatus] = useState(null);
  const [showKycStatusModal, setShowKycStatusModal] = useState(false);
  const [userTierType, setUserTierType] = useState(null);
  const [fiatMarketPrice, setFiatMarketPrice] = useState(0);
  const [bankWithdrawLimit, setBankWithdrawLimit] = useState({
    min: 0.0,
    max: 0.0,
  });
  const [savedBitcoinAddresses, setSavedBitcoinAddresses] = useState([]);
  const [selectedSavedAddress, setSelectedSavedAddress] = useState(null);
  const [addressEntryMode, setAddressEntryMode] = useState("manual");
  const [paybitoAuthModal, setPaybitoAuthModal] = useState(false);
  const [showAddAddressModalforsignup, setShowAddAddressModalforsignup] =
    useState(false);
  const [paybitoGoogleAuthOtpRef, setPaybitoGoogleAuthOtpRefState] =
    useState("");
  const [paybitoGoogleAuthOtpValue, setPaybitoGoogleAuthOtpValue] =
    useState("");
  const [amountError, setAmountError] = useState("");

  // Escrow Wallet
  const [escrowWalletBalance, setEscrowWalletBalance] = useState(null);
  const [escrowWalletCurrency, setEscrowWalletCurrency] = useState("USD");
  const [escrowWalletLoading, setEscrowWalletLoading] = useState(true);
  const [homeCurrencyId, setHomeCurrencyId] = useState(null);
  const [escrowWithdrawStep, setEscrowWithdrawStep] = useState(null); // null | 'brand'
  const [escrowWithdrawTerms, setEscrowWithdrawTerms] = useState(false);
  const [isEscrowWithdraw, setIsEscrowWithdraw] = useState(false);
  const [isEscrowBrandTransfer, setIsEscrowBrandTransfer] = useState(false);
  const [escrowBrandAmount, setEscrowBrandAmount] = useState("");
  const [escrowBrandAmountError, setEscrowBrandAmountError] = useState("");
  const [escrowWithdrawContractNo, setEscrowWithdrawContractNo] = useState("");
  const [escrowContractsPage, setEscrowContractsPage] = useState(1);
  const [escrowContracts, setEscrowContracts] = useState([]);
  const [escrowContractsTotalRecords, setEscrowContractsTotalRecords] = useState(0);
  const [escrowContractsLoading, setEscrowContractsLoading] = useState(false);

  // Refs
  const emailRef = useRef(null);
  const passwordRef = useRef(null);
  const AmountRef = useRef(null);
  const externalAddressRef = useRef(null);
  const signupPhoneRef = useRef(null);
  const brokeridpaybitoRef = useRef(null);
  const signupFirstNameRef = useRef(null);
  const signupLastNameRef = useRef(null);
  const signupEmailRef = useRef(null);
  const signupPasswordRef = useRef(null);
  const signupRePasswordRef = useRef(null);
  const signupMiddleNameRef = useRef(null);
  const recaptchaRef = useRef(null);
  const otpRef = useRef(null);
  const paybitoEmailOtpRef = useRef(null);
  const paybitoGoogleAuthOtpInputRef = useRef(null);
  const loginPaybitoEmailRef = useRef(null);
  const loginPaybitoPswdRef = useRef(null);
  const paybitoRecaptchaRef = useRef(null);
  const loginPaybitoOtpRef = useRef(null);
  const paybitoForgotpswdCaptchRef = useRef(null);
  const paybitoSignUpRecaptchaRef = useRef(null);
  const paybitoForgetPasswordInput = useRef(null);
  const forgotPswdInputEmail = useRef(null);
  const newPswdInputEmail = useRef(null);
  const retypePswdInputEmail = useRef(null);
  const paybitoInputSecureToken = useRef(null);
  const coinTag = useRef(null);
  const externalAddressTransferAmount = useRef(null);
  const paybitoGoogleAuthTranscationOtpRefInput = useRef(null);
  const transferToExternalGoogleAuthCodeRef = useRef(null);
  const transferToExternalEmailOtpRef = useRef(null);
  const smsOtpRef = useRef(null);
  const phoneOtpRef = useRef(null);

  // Timer references for cleanup
  const downloadTimerRef = useRef(null);
  const getCodeTimerRef = useRef(null);
  const smsTimerRef = useRef(null);
  const resendTimerRef = useRef(null);

  console.log("Render Dashboard", savedBitcoinAddresses);

  // Helper functions
  const Eye = () => {
    if (password === "password") {
      setPassword("text");
      setEye(false);
      setType(true);
    } else {
      setPassword("password");
      setEye(true);
      setType(false);
    }
  };

  const validateExternalAddress = useCallback(
    (address) => {
      if (!address) return;

      let payload = {
        currencyId: cryptoIdForTransfer,
        address: address,
        merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      };
      if (cryptoIdForTransfer == 16) {
        payload["tokenType"] = selectedNetworkForTransfer;
      }
      isCryptoAddrValid(payload)
        .then((res) => {
          let response = res.data[0];
          if (response.error != "0") {
            console.log(response.error_msg);
            showToast("error", response.error_msg);
            setIsValidCryptoMsg(response.error_msg);
            setClassForValidCrypto("text-danger");
            setAddressValid(true);
          } else {
            console.log(response);
            setIsValidCryptoMsg(response.error_msg);
            setClassForValidCrypto("text-success");
            setAddressValid(false);
          }
        })
        .catch((err) => {
          setShowLoader(false);
          showHttpError(err);
        });
    },
    [cryptoIdForTransfer, selectedNetworkForTransfer]
  );

  const isAddressValid = (e) => {
    const address = e.target.value;
    setExternalAddress(address);
    validateExternalAddress(address);
  };

  const handleSavedAddressSelect = (e) => {
    const selectedValue = e.target.value;

    if (selectedValue === "add-new") {
      setExternalAddress("");
      setSelectedSavedAddress("");
      setAddressEntryMode("manual");
      history.push("/crypto-address");
      return;
    }

    setSelectedSavedAddress(selectedValue);
    setExternalAddress(selectedValue);
    setAddressEntryMode("saved");
    setIsValidCryptoMsg("");
    setClassForValidCrypto("");
    validateExternalAddress(selectedValue);
  };

  const handleManualEntryMode = () => {
    setAddressEntryMode("manual");
    setSelectedSavedAddress(null);
    setExternalAddress("");
    setIsValidCryptoMsg("");
    setClassForValidCrypto("");
    setAddressValid(true);
  };

  const handleSavedEntryMode = () => {
    setAddressEntryMode("saved");
    setAddressValid(true);
    // setExternalAddress(
    //   selectedSavedAddress?.address ||
    //     (savedBitcoinAddresses.length > 0
    //       ? savedBitcoinAddresses[0].address
    //       : "")
    // );
    // setSelectedSavedAddress(
    //   selectedSavedAddress ||
    //     (savedBitcoinAddresses.length > 0 ? savedBitcoinAddresses[0] : null)
    // );
    // if (selectedSavedAddress?.address) {
    //   validateExternalAddress(selectedSavedAddress.address);
    // }
  };

  const handleCriptoWithdraw = (param) => {
    console.log(param.assetId);
    console.log(param);
    setSelectedAssetForWithdraw(param);

    if (param.assetId == 16) {
      fetchSavedBitcoinAddresses(param.assetId, () => {
        setShowWithdrawOptionModal(false);
        setShowNetworkPopup(true);
        setSelectedAssetNetworkList(param.network);
        setCryptoIdForTransfer(param.assetId);
        setCoinIdForTag(param.assetId);
        setCryptoNameForTransfer(param.assetCode);
        setCoinBalanceAmt(param.coinBalance);
      });
    } else {
      fetchSavedBitcoinAddresses(param.assetId, () => {
        setShowWithdrawOptionModal(true);
        setShowNetworkPopup(false);
        setSelectedNetworkForTransfer(null);
        setSelectedAssetNetworkList(param.network);
        setCryptoIdForTransfer(param.assetId);
        setCoinIdForTag(param.assetId);
        setCryptoNameForTransfer(param.assetCode);
        setCoinBalanceAmt(param.coinBalance);
        setExternalAddress("");
        setSelectedSavedAddress(null);
        setAddressEntryMode("manual");
        setIsValidCryptoMsg("");
        setClassForValidCrypto("");
      });
    }
  };

  const fetchSavedBitcoinAddresses = (currencyId, callback) => {
    const payload = {
      currency_id: currencyId,
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };

    getCryptoAddress(payload)
      .then((res) => {
        const response = res.data;
        if (response?.length !== 0) {
          console.log("Fetched saved addresses:", response);
          setSavedBitcoinAddresses(response);
          if (callback) callback();
        } else {
          setSavedBitcoinAddresses([]);
          if (callback) callback();
        }
      })
      .catch((err) => {
        console.error("Error fetching saved addresses:", err);
        setSavedBitcoinAddresses([]);
        if (callback) callback();
      });
  };

  const handleRenderLedgerAmount = useCallback(() => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    setShowLoader(true);

    FetchUsdBtcLedgerAmount(payload)
      .then((res) => {
        setShowLoader(false);
        let response = res.data[0];
        console.log(response);
        if (response.error != "0") {
          showToast("error", response.error_msg);
        } else {
          if (response != undefined && response != null) {
            let coinBalance = response.coin_balance;
            let arr = [];
            console.log("CoinBalance => ", coinBalance);
            if (coinBalance != undefined) {
              for (let i = 0; i < coinBalance.length; i++) {
                let obj = {
                  assetName: coinBalance[i].currency_name,
                  coinBalance: coinBalance[i].balance,
                  assetCode: coinBalance[i].currency_code,
                  assetId: coinBalance[i].currency_id,
                  assetImage: coinBalance[i].logo,
                  network: coinBalance[i].network,
                  isBrokerCurrency: coinBalance[i].is_broker_currency,
                  currency_type: coinBalance[i].currency_type,
                };
                arr.push(obj);
              }
            }

            setAssets(arr);
            console.log(arr);
            localStorage.setItem(
              SITENAMEALIAS + "_assets",
              JSON.stringify(arr)
            );
            const hc = localStorage.getItem(SITENAMEALIAS + "_home_currency") || "";
            const fiatAsset = arr.find(
              (a) => (a.assetCode || "").toUpperCase() === hc.toUpperCase()
            );
            if (fiatAsset?.assetId) setHomeCurrencyId(fiatAsset.assetId);
          }
          renderUserTransactions();
        }
      })
      .catch((err) => {
        setShowLoader(false);
        showHttpError(err);
      });
  }, []);

  const renderUserTransactions = useCallback(() => {
    let payload = {
      userId: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      pageNo: pageNo,
      noOfItemsPerPage: noOfItemsPerPage,
    };
    setShowLoader(true);
    GetUserTransaction(payload)
      .then((res) => {
        setShowLoader(false);
        let response = res.data[0];
        if (response.error != "0") {
          showToast("error", response.error_msg);
        } else {
          console.log(response.trxnList);
          setUserTransactionList(response.trxnList);
          setTotalCount(response.totalCount);
          renderPaginationPageNo(response.totalCount);
        }
      })
      .catch((err) => {
        setShowLoader(false);
        showHttpError(err);
      });
  }, [pageNo, noOfItemsPerPage]);

  const renderPaginationPageNo = (total) => {
    let maxPageLimit = Math.ceil(parseInt(total) / parseInt(noOfItemsPerPage));
    let pageListArr = [];
    for (let i = 1; i <= maxPageLimit; i++) {
      pageListArr.push(i);
    }
    setPageList(pageListArr);
  };

  const sendMail = useCallback(() => {
    let payload = {
      email: paybitoemail,
    };

    paybitoSentOtpForLogin(payload).then((res) => {
      console.log("paybitosentotp", res);
      let response = res.data;
      if (response.error.error_data != "0") {
        showToast("error", response.error.error_msg);
      } else {
        showToast("success", "OTP has been sent to your mail id");
        setIsTimerStartForPaybitoGetCode(true);
      }
    });
  }, [paybitoemail]);

  const startTimer = useCallback((i) => {
    let count = i;
    setTimer(count);

    if (downloadTimerRef.current) clearInterval(downloadTimerRef.current);

    downloadTimerRef.current = setInterval(() => {
      if (count <= 1) {
        clearInterval(downloadTimerRef.current);
        setSecondStatusCheck(false);
        localStorage.setItem("secondStatusCheck", "false");
        setIsTimerStartForPaybitoGetCode(false);
        downloadTimerRef.current = null;
      }
      count -= 1;
      localStorage.setItem("countdownsec", count);
      setTimer(localStorage.getItem("countdownsec"));
    }, 1000);
  }, []);

  const sendVerificationMail = useCallback(() => {
    sendMail();
    setSecondStatusCheck(true);
    localStorage.setItem("secondStatusCheck", "true");
    let count = "300";
    localStorage.setItem("countdownsec", count);
    startTimer(300);
  }, [sendMail, startTimer]);

  const loginPaybito = useCallback(async () => {
    let token;
    try {
      const result = await paybitoRecaptchaRef.current.verify();
      token = result.token;
    } catch (err) {
      showToast("error", "Captcha verification failed. Please try again.");
      return;
    }
    setPaybitoRecaptchaResponse(token);

    let payload = {
      email: paybitoemail,
      password: paybitopswd,
      ipAddress: localStorage.getItem(SITENAMEALIAS + "ipaddress"),
      latitude: localStorage.getItem(SITENAMEALIAS + "latitude"),
      location: localStorage.getItem(SITENAMEALIAS + "location"),
      longitude: localStorage.getItem(SITENAMEALIAS + "longitude"),
      deviceId: localStorage.getItem("deviceId"),
      deviceType: localStorage.getItem(SITENAMEALIAS + "deviceType"),
      browser: localStorage.getItem(SITENAMEALIAS + "browserName"),
      gRecaptchaResponse: paybitoRecaptchaResponse,
      otp: paybitoOtp,
    };

    paybitoLogin(payload).then((res) => {
      if (res.data.error.error_data == "1") {
        showToast("error", res.data.error.error_msg);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      } else if (res.data.error.error_data == "2") {
        showToast("error", res.data.error.error_msg);
      } else {
        let userid = res.data.userResult.userId;
        localStorage.setItem(
          "paybitoTwoFactorStatus",
          res.data.userResult.twoFactorAuth
        );
        if (res.data.userResult.phoneValidation == "1") {
          localStorage.setItem("paybitoPhoneNumber", res.data.userResult.phone);
          setShowPaybitoMobileSmsAuthModal(true);
          setShowPaybitoOtpModal(false);
          setPaybitoOtp("");
        } else {
          if (res.data.userResult.twoFactorAuth == "1") {
            setShowPaybitoOtpModal(false);
            setShowPaybitoSecurityAuthModal(true);
            setPaybitoOtp("");
          }
          if (res.data.userResult.twoFactorAuth == "0") {
            setPaybitoOtp("");
            let accessToken = res.data.token;
            localStorage.setItem("paybito_access_token", res.data.token);

            const Options = {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                authorization: "BEARER " + accessToken,
              },
              body: JSON.stringify({
                uuid: res.data.userResult.uuid,
                userId: res.data.userResult.userId,
              }),
            };

            fetch(
              "https://accounts.paybito.com/api/user/GetUserDetails",
              Options
            )
              .then((response) => response.json())
              .then((data) => {
                let paybitouserDetails = data.userResult;
                localStorage.setItem(
                  SITENAMEALIAS + "_paybito_id",
                  paybitouserDetails.userId
                );
                localStorage.setItem(
                  SITENAMEALIAS + "_paybito_uuid",
                  paybitouserDetails.uuid
                );
                setShowPaybitoOtpModal(false);
                setPaybitoOtp("");
                localStorage.setItem("countdownsec", "");
                handleRenderLedgerAmount();
              });
          }
        }
      }
    });
  }, [
    paybitoemail,
    paybitopswd,
    paybitoRecaptchaResponse,
    paybitoOtp,
    handleRenderLedgerAmount,
  ]);

  const isPaybitoOtpValid = (e) => {
    setPaybitoOtp(e.target.value);
    setIsButtonDisable(/^\d{8}$/.test(e.target.value));
  };

  const sendSms = useCallback(() => {
    let payload = {
      phone: localStorage.getItem("paybitoPhoneNumber"),
      countryCode: localStorage.getItem("paybitoCountryCode"),
    };
    paybitoLoginMobileOtp(payload).then((res) => {
      let response = res.data;
      if (response.error.error_data != "0") {
        showToast("error", response.error.error_msg);
      } else {
        showToast(
          "success",
          "OTP has been sent to your registered mobile number"
        );
        setIsTimerStartForSmsGetCode(true);
      }
    });
  }, []);

  const startSmsAuthTimer = useCallback((i) => {
    let count = i;
    setGetCodeSmsTimer(count);

    if (smsTimerRef.current) clearInterval(smsTimerRef.current);

    smsTimerRef.current = setInterval(() => {
      if (count <= 1) {
        clearInterval(smsTimerRef.current);
        setIsSecondStatusMobileCheck(false);
        localStorage.setItem("isSecondStatusMobileCheck", "false");
        setIsTimerStartForSmsGetCode(false);
        smsTimerRef.current = null;
      }
      count -= 1;
      localStorage.setItem("smsCodeCountdownsec", count);
      setGetCodeSmsTimer(localStorage.getItem("smsCodeCountdownsec"));
    }, 1000);
  }, []);

  const handleMobileOtp = useCallback(() => {
    sendSms();
    setIsSecondStatusMobileCheck(true);
    localStorage.setItem("isSecondStatusMobileCheck", "true");
    let count = "120";
    localStorage.setItem("smsCodeCountdownsec", count);
    startSmsAuthTimer(120);
  }, [sendSms, startSmsAuthTimer]);

  const paybitoMobileSmsVerify = useCallback(() => {
    if (smsOtpRef.current?.value) {
      setSmsAuthOtp(smsOtpRef.current.value);
    }
  }, []);

  const paybitoGoogleAuthLogin = useCallback(() => {
    if (paybitoGoogleAuthOtpInputRef.current?.value) {
      let payload = {
        email: paybitoemail,
        otp: paybitoGoogleAuthOtpInputRef.current.value,
        password: paybitopswd,
        callFrom: "login",
      };
      checkTwoFactorLogin(payload)
        .then((res) => {
          console.log(res.data);

          let accessToken = res.data.token;
          localStorage.setItem("paybito_access_token", res.data.token);

          const Options = {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: "BEARER " + accessToken,
            },
            body: JSON.stringify({
              uuid: res.data.userResult.uuid,
              userId: res.data.userResult.userId,
            }),
          };

          fetch("https://accounts.paybito.com/api/user/GetUserDetails", Options)
            .then((response) => response.json())
            .then((data) => {
              let paybitouserDetails = data.userResult;
              localStorage.setItem(
                SITENAMEALIAS + "_paybito_id",
                paybitouserDetails.userId
              );
              localStorage.setItem(
                SITENAMEALIAS + "_paybito_uuid",
                paybitouserDetails.uuid
              );
              handleRenderLedgerAmount();
            });
        })
        .catch((err) => {
          setShowLoader(false);
          showHttpError(err);
        });
    }
  }, [paybitoemail, paybitopswd, handleRenderLedgerAmount]);

  const paybitoOtpModal = useCallback(() => {
    if (paybitoemail != "" && paybitopswd != "") {
      setShowCaptchaModal(true);
    }
  }, [paybitoemail, paybitopswd]);

  const handleCaptchaSubmit = useCallback(
    (captcha, sessionId) => {
      let payload = {
        email: paybitoemail,
        password: paybitopswd,
        gRecaptchaResponse: captcha,
        sessionId: sessionId,
      };

      CheckMfaStatus(payload).then((res) => {
        var response = res.data;
        if (response.error.error_data != "0") {
          showToast("error", response.error.error_msg);
        } else {
          localStorage.setItem("paybitoPhoneNumber", response.userResult.phone);
          localStorage.setItem(
            "paybitoCountryCode",
            response.userResult.countryCode
          );
          sendVerificationMail();
          if (response.userResult.twoFactorAuth == "1") {
            setIsTwoFactorAuthOn(true);
          } else {
            setIsTwoFactorAuthOn(false);
          }

          if (response.userResult.phoneValidation == "1") {
            handleMobileOtp();
            setIsPhoneValidationOn(true);
          } else {
            setIsPhoneValidationOn(false);
          }
          setTimeout(() => {
            setPaybitoAuthModal(true);
          }, 2000);
        }
      });
    },
    [paybitoemail, paybitopswd, sendVerificationMail, handleMobileOtp]
  );

  const paybitoUserLogin = useCallback(async () => {
    let token;
    try {
      const result = await paybitoRecaptchaRef.current.verify();
      token = result.token;
    } catch (err) {
      showToast("error", "Captcha verification failed. Please try again.");
      return;
    }
    setPaybitoRecaptchaResponse(token);

    let payload = {
      email: paybitoemail,
      password: paybitopswd,
      ipAddress: localStorage.getItem(SITENAMEALIAS + "ipaddress"),
      latitude: localStorage.getItem(SITENAMEALIAS + "latitude"),
      location: localStorage.getItem(SITENAMEALIAS + "location"),
      longitude: localStorage.getItem(SITENAMEALIAS + "longitude"),
      deviceId: localStorage.getItem("deviceId"),
      deviceType: localStorage.getItem(SITENAMEALIAS + "deviceType"),
      browser: localStorage.getItem(SITENAMEALIAS + "browserName"),
      gRecaptchaResponse: paybitoRecaptchaResponse,
      otp: paybitoEmailOtp,
    };
    if (smsAuthOtp != "") {
      payload["phoneOtp"] = smsAuthOtp;
    }
    if (paybitoGoogleAuthOtp != "") {
      payload["securityCode"] = paybitoGoogleAuthOtp;
    }
    paybitoLogin(payload).then((res) => {
      if (res.data.error.error_data == "1") {
        showToast("error", res.data.error.error_msg);
      } else if (res.data.error.error_data == "2") {
        showToast("error", res.data.error.error_msg);
      } else {
        let userid = res.data.userResult.userId;
        localStorage.setItem(
          "paybitoTwoFactorStatus",
          res.data.userResult.twoFactorAuth
        );

        let accessToken = res.data.token;
        localStorage.setItem("paybito_access_token", res.data.token);

        const Options = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + accessToken,
          },
          body: JSON.stringify({
            uuid: res.data.userResult.uuid,
            userId: res.data.userResult.userId,
          }),
        };

        fetch("https://accounts.paybito.com/api/user/GetUserDetails", Options)
          .then((response) => response.json())
          .then((data) => {
            let paybitouserDetails = data.userResult;
            localStorage.setItem(
              SITENAMEALIAS + "_paybito_id",
              paybitouserDetails.userId
            );
            localStorage.setItem(
              SITENAMEALIAS + "_paybito_uuid",
              paybitouserDetails.uuid
            );
            setShowPaybitoOtpModal(false);
            setPaybitoOtp("");
            localStorage.setItem("smsCodeCountdownsec", "");
            localStorage.setItem("countdownsec", "");
            handleRenderLedgerAmount();
          });
      }
    });
  }, [
    paybitoemail,
    paybitopswd,
    paybitoRecaptchaResponse,
    paybitoEmailOtp,
    smsAuthOtp,
    paybitoGoogleAuthOtp,
    handleRenderLedgerAmount,
  ]);

  const requiresTag = () => {
    const needsTag =
      coinIdForTag == "8" ||
      coinIdForTag == "14" ||
      (coinIdForTag != "" &&
        handleDynamicCurrencyDetiails(assets, coinIdForTag).isBrokerCurrency ==
          1 &&
        handleDynamicCurrencyDetiails(assets, coinIdForTag).network[0] ==
          "HCNET");

    if (!needsTag) return false;

    const isInvalid =
      coinTagValue.trim() === "" || !/^[a-zA-Z0-9]{1,30}$/.test(coinTagValue);
    return isInvalid;
  };

  const isTagInvalid = requiresTag(coinIdForTag, assets, coinTagValue);
  const isDisabled = transferAmtBtn || addressValid || isTagInvalid;

  console.log("requiresTag", requiresTag());

  const handleSignuptoPaybito = () => {
    if (
      signupFirstNameRef.current?.value != "" &&
      signupLastNameRef.current?.value != "" &&
      signupEmailRef.current?.value != "" &&
      signupPhoneRef.current?.value != "" &&
      signupPasswordRef.current?.value != "" &&
      signupRePasswordRef.current?.value != "" &&
      brokeridpaybitoRef.current?.value != ""
    ) {
      setShowCaptchaModalSecond(true);
    } else {
      showToast(
        "error",
        "Please provide valid details, all fields data are mandatory"
      );
    }
  };

  const handleCaptchaSubmitSecond = useCallback(
    (captcha, sessionId) => {
      let payload = {
        brokerId: brokeridpaybitoRef.current.value,
        browser: localStorage.getItem(SITENAMEALIAS + "browserName"),
        country: localStorage.getItem(SITENAMEALIAS + "location"),
        deviceId: localStorage.getItem("deviceId"),
        deviceType: localStorage.getItem(SITENAMEALIAS + "deviceType"),
        email: signupEmailRef.current.value,
        firstName: signupFirstNameRef.current.value,
        gRecaptchaResponse: captcha,
        sessionId: sessionId,
        ipAddress: localStorage.getItem(SITENAMEALIAS + "ipaddress"),
        lastName: signupLastNameRef.current.value,
        latitude: localStorage.getItem(SITENAMEALIAS + "latitude"),
        location: localStorage.getItem(SITENAMEALIAS + "location"),
        longitude: localStorage.getItem(SITENAMEALIAS + "longitude"),
        password: signupPasswordRef.current.value,
        phone: signupPhoneNumberRef,
        countryCode: signupCountryCodeRef,
        repassword1: signupRePasswordRef.current.value,
      };
      paybitoSignUp(payload)
        .then((res) => {
          let response = res.data;
          if (response.error.error_data != "0") {
            showToast("error", response.error.error_msg);
          } else {
            setPaybitoSignUpId(response.userResult.userId);
            setShowOtpModal(true);
          }
        })
        .catch((err) => {
          setShowLoader(false);
          showHttpError(err);
        });
    },
    [signupPhoneNumberRef, signupCountryCodeRef]
  );

  const handleSentOtp = () => {
    if (otpRef.current?.value != "" && otpRef.current?.value != undefined) {
      setShowLoader(true);
      let payload = {
        userId: paybitoSignUpId,
        otp: otpRef.current.value,
      };
      CheckOTP(payload)
        .then((res) => {
          let response = res.data;
          setShowLoader(false);
          if (response.error.error_data != "0") {
            showToast("error", response.error.error_msg);
          } else {
            setShowOtpModal(false);
            setShowAddAddressModal(true);
            handleRenderLedgerAmount();
          }
        })
        .catch((err) => {
          setShowLoader(false);
          showHttpError(err);
        });
    } else {
      showToast("error", "Please provide valid OTP");
    }
  };

  const handleResendOtp = () => {
    let payload = {
      userId: paybitoSignUpId,
    };

    ResendOTP(payload)
      .then((res) => {
        let response = res.data;
        if (response.error.error_data != "0") {
          showToast("error", response.error.error_msg);
        } else {
          startResendOtpTimer(60);
          showToast("success", "OTP send to your registered email");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        showHttpError(err);
      });
  };

  const startResendOtpTimer = useCallback((i) => {
    let count = i;
    setResendOtpTimerTxt(count);

    if (resendTimerRef.current) clearInterval(resendTimerRef.current);

    resendTimerRef.current = setInterval(() => {
      if (count <= 1) {
        clearInterval(resendTimerRef.current);
        setResendOtpSecondStatus(false);
        localStorage.setItem("resendOtpStatusCheck", "false");
        setIsResendOtpTimerStart(false);
        resendTimerRef.current = null;
      }
      count -= 1;
      localStorage.setItem("resendOtpCountdown", count);
      setResendOtpTimerTxt(localStorage.getItem("resendOtpCountdown"));
      setIsResendOtpTimerStart(true);
    }, 1000);
  }, []);

  const handleEmail = () => {
    if (signupEmailRef.current?.value != "") {
      const Options = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: signupEmailRef.current.value }),
      };
      fetch("https://accounts.paybito.com/api/user/CheckEmail", Options)
        .then((response) => response.json())
        .then((data) => {
          var result = data.userResult;
          if (result.checkEmailPhoneFlag == 1) {
            showToast(
              "error",
              "Email already registered , please try with another email address"
            );
            signupEmailRef.current.value = "";
          }
        });
    }
  };

  const handlePhone = (e) => {
    signupPhoneRef.current.value = e.target.value.replace(/[^A-Z0-9]/gi, "");
    let phoneNumber = signupPhoneRef.current.value;
    setSignupPhoneNumberRef(phoneNumber.slice(-10));
    setSignupCountryCodeRef(phoneNumber.slice(0, -10));

    if (
      signupPhoneRef.current?.value != "" &&
      signupPhoneRef.current?.value != undefined
    ) {
      let phoneVal = signupPhoneRef.current.value;
      if (phoneVal.length <= 8 || phoneVal.length >= 18) {
        setPhoneErrorMsg(true);
      } else {
        const Options = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            phone: signupPhoneNumberRef,
            countryCode: signupCountryCodeRef,
          }),
        };
        fetch("https://accounts.paybito.com/api/user/CheckPhone", Options)
          .then((response) => response.json())
          .then((data) => {
            var result = data;
            if (result.error.error_data != "0") {
              showToast(result.error.error_msg, "error");
            } else {
              if (result.checkEmailPhoneFlag == 1) {
                showToast(
                  "error",
                  "Phone No. already registered , please try with another phone no."
                );
                signupPhoneRef.current.value = "";
              }
            }
          });
      }
    } else {
      showToast("error", "please provide phone number");
    }
  };

  const handleMatchPassword = () => {
    let status = false;
    let regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.$!])[A-Za-z\d@.$!]{8,35}$/gm;
    let inputVal = signupPasswordRef.current?.value;
    let result = regex.test(inputVal);
    console.log(result);
    if (result === true) {
      setIsPasswordValid(false);
      if (
        signupPasswordRef.current?.value === signupRePasswordRef.current?.value
      ) {
        status = true;
      } else {
        status = false;
      }
      setIsPasswordMatched(status);
    } else {
      setIsPasswordValid(true);
    }
  };

  const balenceTranfertoPaybitoModal = useCallback(
    (param) => {
      if (permission == "WRITE") {
        let payload = {
          currencyId: param.assetId,
          merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
        };
        if (param.assetId == "16") {
          payload["tokenType"] = "erc";
        } else if (param.assetId == "148") {
          payload["tokenType"] = "erc";
        }
        getFeesByCurrencyId(payload)
          .then((res) => {
            let response = res.data;
            console.log(response);
            setMinFee(response[0].MIN_FEE);
            setFromFee(response[0].FROMFEE);
            setToFee(response[0].TOFEE);
            setFeeRate(response[0].FEE_RATE);
            setCurrencyPrecision(response[0].CURRENCY_PRECISION);
          })
          .catch((err) => {
            setShowLoader(false);
            showHttpError(err);
          });

        setCryptoIdForTransfer(param.assetId);
        setTransferModal(true);
      } else {
        showToast("error", "You need write access to perform this operation");
      }
    },
    [permission]
  );

  const closeTransferModal = (e) => {
    e.preventDefault();
    if (isTestMode) {
      showToast("error", "This feature is not available for test mode");
      return;
    }
    if (Number(selectedAssetForWithdraw.coinBalance) <= Number(amount)) {
      showToast("error", "Insufficient Balance");
    } else {
      handleExchangeUserDetails();
    }
  };

  const fetchEscrowContracts = useCallback((page) => {
    const merchantId = localStorage.getItem(SITENAMEALIAS + "_merchant_id");
    if (!merchantId) return;
    setEscrowContractsLoading(true);
    fetch(
      `${WEBSERVICE}/escrow/released?merchantId=${merchantId}&pageNumber=${page}&pageSize=10`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "bearer " + getAuthToken(),
          UUID: getAuthUuid(),
        },
      }
    )
      .then((r) => r.json())
      .then((data) => {
        if (data?.returnId === 1) {
          setEscrowContracts(data?.data ?? []);
          setEscrowContractsTotalRecords(data?.totalRecords ?? 0);
        } else {
          setEscrowContracts([]);
          setEscrowContractsTotalRecords(0);
        }
      })
      .catch(() => {
        setEscrowContracts([]);
        setEscrowContractsTotalRecords(0);
      })
      .finally(() => setEscrowContractsLoading(false));
  }, []);

  const transferEscrowToBrandWallet = () => {
    const merchantId = localStorage.getItem(SITENAMEALIAS + "_merchant_id");
    const customerId = localStorage.getItem(SITENAMEALIAS + "_paybito_id");
    setShowLoader(true);
    fetch(`${WEBSERVICE}/escrow/transfer-escrow-to-wallet`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
      body: JSON.stringify({
        contractNo: escrowWithdrawContractNo,
        customerId: customerId,
        merchantId: merchantId,
        amount: parseFloat(escrowBrandAmount),
      }),
    })
      .then((r) => r.json())
      .then((data) => {
        setShowLoader(false);
        if (data?.returnId !== 1) {
          showToast("error", data?.message || "Transfer failed");
          return;
        }
        showToast("success", data?.message || "Transfer successful");
        setIsEscrowBrandTransfer(false);
        setIsEscrowWithdraw(false);
        setEscrowWithdrawStep(null);
        setEscrowWithdrawTerms(false);
        setEscrowBrandAmount("");
        setEscrowBrandAmountError("");
        setEscrowContractsPage(1);
        fetchEscrowContracts(1);
      })
      .catch((err) => {
        setShowLoader(false);
        showHttpError(err);
      });
  };

  const fetchExchangeUserAndStore = async () => {
    const payload = {
      merchantId: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      brokerId: localStorage.getItem(SITENAMEALIAS + "_brokerId"),
      uuid: getAuthUuid(),
    };
    const loginRes = await fetch(`${WEBSERVICE}/merchant/auto-login/exchange`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getAuthToken(),
        UUID: getAuthUuid(),
      },
      body: JSON.stringify(payload),
    });
    const loginData = await loginRes.json();
    if (loginData.error?.error_data != "0") {
      throw new Error(loginData.error?.error_message || "Exchange login failed");
    }
    const { token, uuid, userId } = loginData;
    localStorage.setItem("paybito_access_token", token);

    const userRes = await fetch("https://accounts.paybito.com/api/user/GetUserDetails", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: "BEARER " + token,
      },
      body: JSON.stringify({ uuid, userId }),
    });
    const userData = await userRes.json();
    const paybitouserDetails = userData.userResult;
    localStorage.setItem(SITENAMEALIAS + "_paybito_id", paybitouserDetails.userId);
    localStorage.setItem(SITENAMEALIAS + "_paybito_uuid", paybitouserDetails.uuid);

    return { token, uuid };
  };

  const handleEscrowBrandConfirm = async () => {
    if (isTestMode) {
      showToast("error", "This feature is not available for test mode");
      return;
    }
    if (Number(escrowBrandAmount) <= 0) {
      showToast("error", "Amount must be greater than 0");
      return;
    }
    if (Number(escrowBrandAmount) > Number(escrowWalletBalance)) {
      showToast("error", "Amount must be less than or equal to contract amount");
      return;
    }

    const existingPaybitoId = localStorage.getItem(SITENAMEALIAS + "_paybito_id");
    if (!existingPaybitoId) {
      setShowLoader(true);
      try {
        await fetchExchangeUserAndStore();
      } catch (err) {
        setShowLoader(false);
        showToast("error", err.message || "Failed to fetch exchange user details. Please try again.");
        return;
      }
    }

    setEscrowWithdrawStep(null);
    transferEscrowToBrandWallet();
  };

  const balanceTransfertoPaybito = (token, uuid) => {
    if (permission == "WRITE") {
      const Options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + token,
        },
        body: JSON.stringify({
          uuid: uuid,
        }),
      };

      fetch("https://accounts.paybito.com/api/user/userAccountStatus", Options)
        .then((response) => response.json())
        .then((data) => {
          if (data.status != "1") {
            showToast("error", "Your user has been blocked by Admin");
            setTransferModal(false);
            setAmount("");
          } else {
            let payload = {
              merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
            };
            setShowLoader(true);

            FetchUserSettings(payload)
              .then((res) => {
                setShowLoader(false);
                let response = res.data[0];
                if (response.error != "0") {
                  showToast("error", response.error_msg);
                } else {
                  if (response.google_auth_enabled == "1") {
                    // Settlement flow sets amount from the Amount input ref;
                    // Escrow brand flow pre-sets paybitoTransferAmt in localStorage before calling this,
                    // so only overwrite when the ref has a value.
                    if (AmountRef.current?.value) {
                      localStorage.setItem("paybitoTransferAmt", AmountRef.current.value);
                    }
                    localStorage.setItem("currencyId", cryptoIdForTransfer);
                    setShowPaybitoSecurityAuthTranscationModal(true);
                    setTransferModal(false);
                    setAmount("");
                  } else {
                    showToast(
                      "error",
                      "Please turn on Google Authentication from Settings first"
                    );
                    setTransferModal(false);
                    setAmount("");
                  }
                }
              })
              .catch((err) => {
                setShowLoader(false);
                console.log("err", err);
                showHttpError(err);
              });
          }
        });
    } else {
      showToast("error", "You need write access to perform this operation");
    }
  };
  console.log("selectedasset", selectedAssetForWithdraw);

  const transferToPaybitoWallet = () => {
    setShowLoader(true);
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      customerId: localStorage.getItem(SITENAMEALIAS + "_paybito_id"),
      amount: localStorage.getItem("paybitoTransferAmt"),
      currencyId:
        selectedAssetForWithdraw?.assetId || localStorage.getItem("currencyId"),
      type: "Transfer",
    };
    payload["secure_token"] =
      paybitoGoogleAuthTranscationOtpRefInput.current?.value;

    transferBalencetoPaybito(payload)
      .then((params) => {
        setShowLoader(false);
        let response = params.data[0];
        if (response.error != "0") {
          showToast("error", response.error_msg);
        } else {
          setShowPaybitoSecurityAuthTranscationModal(false);
          showToast("success", response.error_msg);
          handleRenderLedgerAmount();
          if (isEscrowBrandTransfer) {
            setIsEscrowBrandTransfer(false);
            setIsEscrowWithdraw(false);
            setEscrowWithdrawStep(null);
            setEscrowWithdrawTerms(false);
            setEscrowBrandAmount("");
            setEscrowBrandAmountError("");
          }
        }
      })
      .catch((err) => {
        setShowLoader(false);
        showHttpError(err);
      });
  };

  const transferAmt = () => {
    if (AmountRef.current?.value == "") {
      setAmtTransferBtn(true);
    } else {
      let inputAmt = parseFloat(AmountRef.current.value);
      if (inputAmt >= fromFee && inputAmt <= toFee) {
        setAmtTransferBtn(false);
      } else {
        setAmtTransferBtn(true);
      }
    }
  };

  const getHcxXrpOtherWalletValue = useCallback(() => {
    console.log(
      "Fetched saved addresses savedBitcoinAddresses:",
      savedBitcoinAddresses
    );
    let payload = {
      currencyId: coinIdForTag,
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    if (coinIdForTag == "16") {
      payload["tokenType"] = selectedNetworkForTransfer;
    } else if (coinIdForTag == "148") {
      payload["tokenType"] = "erc";
    }
    setNetworkCoin(coinIdForTag);
    getFeesByCurrencyId(payload)
      .then((res) => {
        let response = res.data;
        setMinFee(response[0].MIN_FEE);
        setFromFee(response[0].FROMFEE);
        setToFee(response[0].TOFEE);
        setFeeRate(response[0].FEE_RATE);
        setCurrencyPrecision(response[0].CURRENCY_PRECISION);
        setTransferCurrencyName(response[0].CURRENCY);
        console.log(response[0].MIN_FEE);
      })
      .catch((err) => {
        setShowLoader(false);
        showHttpError(err);
      });

    setShowExternalAddressModal(true);
    setShowWithdrawOptionModal(false);
  }, [coinIdForTag, selectedNetworkForTransfer, savedBitcoinAddresses]);

  const setNetworkCoin = (currencyId) => {
    if (
      currencyId == 25 ||
      currencyId == 27 ||
      currencyId == 37 ||
      currencyId == 16 ||
      currencyId == 159 ||
      currencyId == 150 ||
      currencyId == 157 ||
      currencyId == 162 ||
      currencyId == 167 ||
      currencyId == 145 ||
      currencyId == 146 ||
      currencyId == 148 ||
      currencyId == 155 ||
      currencyId == 156 ||
      currencyId == 158 ||
      currencyId == 151 ||
      currencyId == 152 ||
      currencyId == 153 ||
      currencyId == 154 ||
      currencyId == 160 ||
      currencyId == 161 ||
      currencyId == 3 ||
      currencyId == 731 ||
      currencyId == 782
    ) {
      setNetwork("ERC 20");
    } else if (currencyId == 2) {
      setNetwork("BTC");
    } else if (currencyId == 8) {
      setNetwork("HCX");
    } else {
      setNetwork(cryptoNameForTransfer);
    }
  };

  const maxSendAmount = useCallback(() => {
    setIsButtonDisable(false);

    let sendMaxAmout = (
      coinBalanceAmt -
      minFee -
      ((coinBalanceAmt - minFee) * feeRate) / 100
    ).toFixed(currencyPrecision);

    if (coinBalanceAmt <= minFee) {
      if (externalAddressTransferAmount.current) {
        externalAddressTransferAmount.current.value = 0;
      }
      setNetworkFee("");
    } else {
      if (externalAddressTransferAmount.current) {
        externalAddressTransferAmount.current.value = sendMaxAmout;
      }
      setTransferAmtBtn(false);
    }

    if (externalAddressTransferAmount.current?.value == 0) {
      setTransferAmtBtn(true);
    } else {
      setTransferAmtBtn(false);
    }
    if (sendMaxAmout > 0) {
      let payload = {
        sendAmount: externalAddressTransferAmount.current?.value,
        currency: cryptoNameForTransfer,
        merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      };
      getFees(payload)
        .then((res) => {
          let response = res.data[0];
          if (response.error != "0") {
          } else {
            let estimatedNetworkFee = response.feesList[0].totalFees.toFixed(
              response.feesList[0].currencyPrecision
            );
            console.log(estimatedNetworkFee);
            setNetworkFee(estimatedNetworkFee);
            setTransferAmtBtn(false);
          }
        })
        .catch((err) => {
          setShowLoader(false);
          showHttpError(err);
        });
    } else {
      setTransferAmtBtn(true);
    }
  }, [
    coinBalanceAmt,
    minFee,
    feeRate,
    currencyPrecision,
    cryptoNameForTransfer,
  ]);

  const rate = (e) => {
    let payload = {
      sendAmount: e.target.value,
      currency: cryptoNameForTransfer,
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    getFees(payload)
      .then((res) => {
        let response = res.data[0];
        if (response.error != "0") {
          setNetworkFee("0");
          setTransferAmtBtn(true);
        } else {
          if (
            e.target.value < response.feesList[0].fromFee ||
            e.target.value > response.feesList[0].toFee
          ) {
            setTransferAmtBtn(true);
          } else {
            let networkfee = response.feesList[0].totalFees.toFixed(
              response.feesList[0].currencyPrecision
            );
            setNetworkFee(networkfee);
            setTransferAmtBtn(false);
          }
        }
      })
      .catch((err) => {
        setShowLoader(false);
        showHttpError(err);
      });
  };

  const handleTranferToExternalAddress = useCallback(() => {
    if (isTestMode) {
      showToast("error", "This feature is not available for test mode");
      return;
    }
    if (
      Number(amountForTransferToExternalAddress) >
      Number(selectedAssetForWithdraw?.coinBalance)
    ) {
      showToast("error", "Insufficient Balance");
      return;
    }
    if (
      externalAddress != "" &&
      amountForTransferToExternalAddress != "" &&
      isValidCryptoMsg === "valid address" &&
      amountForTransferToExternalAddress != 0
    ) {
      setExternalAddress(externalAddress);
      if (
        cryptoIdForTransfer == 14 ||
        cryptoIdForTransfer == 8 ||
        (handleDynamicCurrencyDetiails(assets, cryptoIdForTransfer)
          .isBrokerCurrency == 1 &&
          handleDynamicCurrencyDetiails(assets, cryptoIdForTransfer)
            .network[0] == "HCNET")
      ) {
        console.log("memo is", coinTagValue);
        setExternalWalletCoinTag(coinTagValue || "");
      }

      let isGoogleAuthEnabled = localStorage.getItem(
        SITENAMEALIAS + "_is_google_auth_enabled"
      );
      if (isGoogleAuthEnabled == "1") {
        setShowExternalWalletAuthModal(true);
        setShowExternalAddressModal(false);
      } else {
        showToast(
          "error",
          "Please Turn on Google Authentication from Settings First."
        );
      }
    } else {
      showToast("error", "Please provide valid address and amount");
    }
  }, [
    externalAddress,
    amountForTransferToExternalAddress,
    isValidCryptoMsg,
    cryptoIdForTransfer,
    assets,
  ]);

  const externalWalletOtpVerificationMail = useCallback(() => {
    sendMailForExternalWallet();
    setIsSecondStatusCheck(true);
    localStorage.setItem("isSecondStatusCheck", "true");
    let count = "120";
    localStorage.setItem("externalWalletCountdownsec", count);
    startGetCodeTimer(120);
  }, []);

  const sendMailForExternalWallet = useCallback(() => {
    let payload = {
      email: localStorage.getItem(SITENAMEALIAS + "_email"),
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };

    coinSendToOther(payload).then((res) => {
      console.log("externalwalletsendotp", res);
      let response = res.data[0];
      if (response.error != "0") {
        showToast("error", response.error_msg);
      } else {
        showToast("success", "OTP has been sent to your email id");
        setIsTimerStartForExternalWalletGetCode(true);
      }
    });
  }, []);

  const startGetCodeTimer = useCallback((i) => {
    let count = i;
    setGetCodeTimer(count);

    if (getCodeTimerRef.current) clearInterval(getCodeTimerRef.current);

    getCodeTimerRef.current = setInterval(() => {
      if (count <= 1) {
        clearInterval(getCodeTimerRef.current);
        setIsSecondStatusCheck(false);
        localStorage.setItem("isSecondStatusCheck", "false");
        setIsTimerStartForExternalWalletGetCode(false);
        getCodeTimerRef.current = null;
      }
      count -= 1;
      localStorage.setItem("externalWalletCountdownsec", count);
      setGetCodeTimer(localStorage.getItem("externalWalletCountdownsec"));
    }, 1000);
  }, []);

  const transferToExternal = useCallback(() => {
    let payload = {
      userId: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      currencyId: cryptoIdForTransfer,
      sendAmount: amountForTransferToExternalAddress,
      toAdd: externalAddress,
      otp: transferToExternalEmailOtpRef.current?.value,
      email: localStorage.getItem(SITENAMEALIAS + "_email"),
      secure_token: transferToExternalGoogleAuthCodeRef.current?.value,
    };
    if (externalWalletCoinTag != "") {
      payload["memo"] = externalWalletCoinTag;
    }
    if (cryptoIdForTransfer == "16") {
      payload["tokenType"] = selectedNetworkForTransfer;
    }
    SendToOther(payload)
      .then((res) => {
        setShowLoader(false);
        let response = res.data[0];
        if (response.error != "0") {
          showToast("error", response.error_msg);
        } else {
          setShowExternalWalletAuthModal(false);
          handleRenderLedgerAmount();
          showToast("success", "Amount has been transferred successfully");
          localStorage.setItem("externalWalletCountdownsec", "");
          setShowExternalAddressModal(false);
        }
      })
      .catch((err) => {
        setShowLoader(false);
        showHttpError(err);
      });
  }, [
    cryptoIdForTransfer,
    amountForTransferToExternalAddress,
    externalAddress,
    externalWalletCoinTag,
    selectedNetworkForTransfer,
    handleRenderLedgerAmount,
  ]);

  const validatePassword = () => {
    var elmVal = newPswdInputEmail.current?.value;
    var regex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.$!])[A-Za-z\d@.$!]{8,35}$/gm;

    if (!regex.test(elmVal)) {
      setPswdnotmatched(true);
      setChangePswd(true);
    } else {
      setPswdnotmatched(false);
      setChangePswd(false);
    }
  };

  const passwordMatched = () => {
    let password = newPswdInputEmail.current?.value;
    let rePassword = retypePswdInputEmail.current?.value;

    if (password == rePassword) {
      setIsPasswordMatched(true);
      setChangePswd(false);
    } else {
      setIsPasswordMatched(false);
      setChangePswd(true);
    }
  };

  const handleForgotPasswordPaybito = () => {
    if (paybitoForgetPasswordInput.current?.value != "") {
      let payload = {
        email: paybitoForgetPasswordInput.current.value,
      };
      paybitoSentOtp(payload)
        .then((res) => {
          let response = res.data;
          if (response.error.error_data != "0") {
            showToast("error", response.error.error_msg);
          } else {
            setPaybitoForgetPswdModal(false);
            showToast("success", "Secure-token sent to your email id");
          }
        })
        .catch((err) => {
          setShowLoader(false);
          showHttpError(err);
        });
    } else {
      showToast(
        "error",
        "Please provide valid details, all fields data are mandatory"
      );
    }
  };

  const handleResetPasswordPaybito = () => {
    if (
      forgotPswdInputEmail.current?.value != "" &&
      newPswdInputEmail.current?.value != "" &&
      retypePswdInputEmail.current?.value != "" &&
      paybitoInputSecureToken.current?.value != "" &&
      paybitoForgotpswdCaptchRef.current?.value != ""
    ) {
      setShowCaptchaModalThird(true);
    } else {
      showToast(
        "error",
        "Please provide valid details, all fields data are mandatory"
      );
    }
  };

  const handleCaptchaSubmitThird = useCallback((captcha, sessionId) => {
    let payload = {
      email: forgotPswdInputEmail.current.value,
      password: newPswdInputEmail.current.value,
      repassword1: retypePswdInputEmail.current.value,
      secureToken: paybitoInputSecureToken.current.value,
      gRecaptchaResponse: captcha,
      sessionId: sessionId,
    };
    paybitoResetPassword(payload)
      .then((res) => {
        let response = res.data;
        if (response.error.error_data != "0") {
          showToast("error", response.error.error_msg);
        } else {
          setPaybitoResetPswdModal(false);
          showToast("success", "Password reset successful. Please login.");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        showHttpError(err);
      });
  }, []);

  const handleExchangeUserDetails = useCallback(async () => {
    setShowLoader(true);
    try {
      const { token, uuid } = await fetchExchangeUserAndStore();
      setShowLoader(false);
      showToast(
        "success",
        "We are initializing the session with exchange, please wait for few seconds and do not refresh or close the page."
      );
      setIsLoggedInToExchange(true);
      setShowWithdrawOptionModal(false);
      balanceTransfertoPaybito(token, uuid);
    } catch (error) {
      setShowLoader(false);
      showToast("error", error.message || "Failed to initialize session with exchange.");
    }
  }, [selectedAssetForWithdraw, balenceTranfertoPaybitoModal]);

  const handleInitiateWithdrawToBankAccount = useCallback(async () => {
    if (
      localStorage.getItem(SITENAMEALIAS + "_is_google_auth_enabled") !== "1"
    ) {
      showToast("error", "Please turn on Google Authentication in Settings.");
      return;
    }
    setShowLoader(true);
    try {
      const res = await GetUserDetails();
      const userDetails = res.data;
      console.log(userDetails);

      const userDocsStatusVal = userDetails.userDocsStatus;
      setBankDetailsStatus(userDetails.bankDetailsStatus);
      setUserDocsStatus(userDocsStatusVal);
      setUserTierType(userDetails?.userTierType);

      const docsStatusStr = String(userDocsStatusVal);
      if (
        userDocsStatusVal === null ||
        userDocsStatusVal === undefined ||
        docsStatusStr === "null" ||
        docsStatusStr !== "1"
      ) {
        setShowLoader(false);
        setShowKycStatusModal(true);
        setShowWithdrawOptionModal(false);
        return;
      }

      getBankWithdrawLimit(
        selectedAssetForWithdraw?.assetCode,
        userDetails?.userTierType
      );

      try {
        const convertRes = await ConvertPrice(
          selectedAssetForWithdraw?.assetCode,
          homeCurrency
        );
        if (convertRes.data.error.error_data === 1) {
          showToast("error", convertRes.data.error.error_msg);
          setShowLoader(false);
          return;
        }
        const marketPrice = convertRes.data.marketPrice;
        setFiatMarketPrice(marketPrice);
        try {
          const res = await GetUserBankDetails();
          const bank = res.data;
          const error = bank.error;
          if (error.error_data === 1) {
            showToast("error", error.error_msg);
            setShowLoader(false);
            return;
          }
          const bankDetails = bank.bankDetails;
          setMerchantBankDetails(bankDetails);
          setShowLoader(false);
          setShowBankTransferModal(true);
          setShowWithdrawOptionModal(false);
          setCryptoAmountForBank("");
          setFiatEquivalentAmount("");
        } catch (error) {
          setShowLoader(false);
          showHttpError(error);
        }
      } catch (error) {
        setShowLoader(false);
        showHttpError(error);
      }
    } catch (error) {
      setShowLoader(false);
      showHttpError(error);
    }
  }, [selectedAssetForWithdraw, homeCurrency]);

  const handleInitiateEscrowWithdrawToBank = useCallback(async () => {
    setShowLoader(true);
    try {
      const res = await GetUserDetails();
      const userDetails = res.data;

      const userDocsStatusVal = userDetails.userDocsStatus;
      const bankStatus = userDetails.bankDetailsStatus;
      setBankDetailsStatus(bankStatus);
      setUserDocsStatus(userDocsStatusVal);
      setUserTierType(userDetails?.userTierType);

      const docsStatusStr = String(userDocsStatusVal);
      if (
        userDocsStatusVal === null ||
        userDocsStatusVal === undefined ||
        docsStatusStr === "null" ||
        docsStatusStr !== "1"
      ) {
        setShowLoader(false);
        setShowKycStatusModal(true);
        setShowWithdrawOptionModal(false);
        return;
      }

      getBankWithdrawLimit(
        selectedAssetForWithdraw?.assetCode,
        userDetails?.userTierType
      );

      if (bankStatus === "2") {
        try {
          const bankRes = await GetUserBankDetails();
          const bank = bankRes.data;
          const error = bank.error;
          if (error.error_data === 1) {
            showToast("error", error.error_msg);
            setShowLoader(false);
            return;
          }
          setMerchantBankDetails(bank.bankDetails);
        } catch (error) {
          setShowLoader(false);
          showHttpError(error);
          return;
        }
      }

      setShowLoader(false);
      setShowBankTransferModal(true);
      setShowWithdrawOptionModal(false);
      setCryptoAmountForBank("");
      setFiatEquivalentAmount("");
    } catch (error) {
      setShowLoader(false);
      showHttpError(error);
    }
  }, [selectedAssetForWithdraw]); 

  const getBankWithdrawLimit = async (assetCode, userTierType) => {
    try {
      const res = await GetTransactionLimitByTier(homeCurrency, userTierType);
      const data = res.data;
      if (data.error && data.error.error_data === 1) {
        showToast("error", data.error.error_msg);
        return;
      }
      setBankWithdrawLimit({
        min: data.minLimit,
        max: data.dailySendLimit,
      });
    } catch (error) {
      setShowLoader(false);
      showHttpError(error);
    }
  };

  const handleCryptoAmountChange = (e) => {
    const amount = e.target.value;
    const mockRate = fiatMarketPrice;
    const fiat =
      amount !== "" && !isNaN(amount)
        ? (parseFloat(amount) * mockRate).toFixed(2)
        : "";
    setCryptoAmountForBank(amount);
    setFiatEquivalentAmount(fiat);
    const maxAmount = parseFloat(bankWithdrawLimit?.max);
    const minAmount = parseFloat(bankWithdrawLimit?.min);
    let error = "";
    // Block update entirely if value exceeds max
    if (!isNaN(fiat) && maxAmount && fiat > maxAmount) {
      error = `Maximum amount is ${bankWithdrawLimit?.max}`;
    }

    if (!isNaN(fiat) && minAmount && fiat < minAmount) {
      error = `Minimum amount is ${bankWithdrawLimit?.min}`;
    }
    setAmountErrorBank(error);
  };

  const isOtpValid = googleAuthOtpForBankWithdraw.toString().length === 6;

  // const isWithdrawDisabled =
  //   !cryptoAmountForBank ||
  //   parseFloat(cryptoAmountForBank) <= 0 ||
  //   parseFloat(cryptoAmountForBank) >
  //     parseFloat(selectedAssetForWithdraw?.coinBalance || 0) ||
  //   parseFloat(fiatEquivalentAmount) <
  //     parseFloat(bankWithdrawLimit?.min || 0) ||
  //   parseFloat(fiatEquivalentAmount) >
  //     parseFloat(bankWithdrawLimit?.max || 0) ||
  //   !isOtpValid;

  const isWithdrawDisabled =
    !cryptoAmountForBank ||
    parseFloat(fiatEquivalentAmount) <= 0 ||
    parseFloat(fiatEquivalentAmount) <
      parseFloat(bankWithdrawLimit?.min || 0) || // < not <=
    parseFloat(fiatEquivalentAmount) >
      parseFloat(bankWithdrawLimit?.max || 0) || // > not >=
    !isOtpValid;

  const handleBankWithdraw = async () => {
    if (isTestMode) {
      showToast("error", "This feature is not available for test mode");
      return;
    }
    if (
      Number(cryptoAmountForBank) >
      Number(selectedAssetForWithdraw?.coinBalance)
    ) {
      showToast("error", "Insufficient balance for this withdrawal amount");
      return;
    }
    if (googleAuthOtpForBankWithdraw === "") {
      showToast("error", "Please provide Google Authentication OTP");
      return;
    }
    if (cryptoAmountForBank === "") {
      showToast("error", "Please provide crypto amount");
      return;
    }
    const payload = {
      userUuid: localStorage.getItem(SITENAMEALIAS + "_exchange_uuid"),
      merchantUuid: getAuthUuid(),
      merchantId: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      securityCode: googleAuthOtpForBankWithdraw,
      amount: cryptoAmountForBank,
      fiatAmount: fiatEquivalentAmount,
      currencyId: selectedAssetForWithdraw.assetId,
      fiatCurrencyCode: localStorage.getItem(SITENAMEALIAS + "_home_currency"),
      bankId: merchantBankDetails?.bankDetailsId,
    };
    try {
      const response = await CreateWithdrawalRequest(JSON.stringify(payload));
      const res = response.data;
      const error = res.error;
      if (error.error_data !== 0) {
        showToast("error", error.error_message);
        return;
      }

      showToast("success", "Bank withdrawal request submitted");
      handleRenderLedgerAmount();
      setShowBankTransferModal(false);
    } catch (error) {
      setShowLoader(false);
      showHttpError(error);
    }
  };

  const logoutPaybito = () => {
    localStorage.removeItem(SITENAMEALIAS + "_paybito_uuid");
    localStorage.removeItem(SITENAMEALIAS + "_paybito_password");
    localStorage.removeItem("paybito_access_token");
    localStorage.removeItem(SITENAMEALIAS + "_paybito_id");
    localStorage.removeItem("paybitoUserid");
    localStorage.removeItem("paybitoPhoneNumber");
    localStorage.removeItem("paybitoTwoFactorStatus");
    handleRenderLedgerAmount();
  };

  // States for modals that weren't declared
  const [showExternalAddressModal, setShowExternalAddressModal] =
    useState(false);
  const [setStateHandler] = useState(() => (newState) => {
    Object.entries(newState).forEach(([key, value]) => {
      switch (key) {
        case "showCaptchaModal":
          setShowCaptchaModal(value);
          break;
        case "showCaptchaModalSecond":
          setShowCaptchaModalSecond(value);
          break;
        case "showCaptchaModalThird":
          setShowCaptchaModalThird(value);
          break;
        default:
          break;
      }
    });
  });

  // Cleanup timers on unmount
  useEffect(() => {
    return () => {
      if (downloadTimerRef.current) clearInterval(downloadTimerRef.current);
      if (getCodeTimerRef.current) clearInterval(getCodeTimerRef.current);
      if (smsTimerRef.current) clearInterval(smsTimerRef.current);
      if (resendTimerRef.current) clearInterval(resendTimerRef.current);
    };
  }, []);

  // ComponentDidMount equivalent
  useEffect(() => {
    setPermission(currentPageAccess());

    if (localStorage.getItem(SITENAMEALIAS + "deviceId", uuid()) != undefined) {
    } else {
      localStorage.setItem(SITENAMEALIAS + "deviceId", uuid());
    }

    if (isMobile) {
      localStorage.setItem(SITENAMEALIAS + "deviceType", "mobile");
    }
    if (isBrowser) {
      localStorage.setItem(SITENAMEALIAS + "deviceType", "Desktop browser");
    }
    localStorage.setItem(
      SITENAMEALIAS + "browserName",
      `${browserName} ${browserVersion}`
    );

    ipgeolocation().then(function (res) {
      localStorage.setItem(SITENAMEALIAS + "latitude", res.data.latitude);
      localStorage.setItem(SITENAMEALIAS + "longitude", res.data.longitude);
      localStorage.setItem(SITENAMEALIAS + "ipaddress", res.data.ip);
      localStorage.setItem(SITENAMEALIAS + "location", res.data.country_name);
    });

    const exchangeLoginStatus = localStorage.getItem(
      SITENAMEALIAS + "_paybito_id"
    )
      ? true
      : false;
    setIsLoggedInToExchange(exchangeLoginStatus);

    let date = new Date(),
      y = date.getFullYear(),
      m = date.getMonth(),
      d = date.getDate();
    let startDay = new Date(y, m, d - 15);
    let endDay = new Date(y, m, d);
    let startTime = "00:00:00";
    let endTime = "23:59:00";
    startDay =
      startDay.getFullYear() +
      "-" +
      (startDay.getMonth() + 1) +
      "-" +
      startDay.getDate();
    startDay = startDay + " " + startTime;
    endDay =
      endDay.getFullYear() +
      "-" +
      (endDay.getMonth() + 1) +
      "-" +
      endDay.getDate();
    endDay = endDay + " " + endTime;

    setSelectedAsset({
      assetId: 3,
      assetCode: "BCH",
      assetImage: BchLogo,
      assetName: "Bitcoin Cash",
    });
    setStartDate(startDay);
    setEndDate(endDay);
    setSelectionRangeForDateRange({
      startDate: startDay,
      endDate: endDay,
      key: "selection",
    });
    handleRenderLedgerAmount();

    // Fetch Escrow Wallet balance
    const escrowMerchantId = localStorage.getItem(SITENAMEALIAS + "_merchant_id");
    if (escrowMerchantId) {
      fetch(`${WEBSERVICE}/escrow/get-funded-contracts-balance?merchantId=${escrowMerchantId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "bearer " + getAuthToken(),
          UUID: getAuthUuid(),
        },
      })
        .then((r) => r.json())
        .then((data) => {
          const bal = data?.data?.inEscrow ?? 0;
          const cur = localStorage.getItem(SITENAMEALIAS + "_home_currency") || "USD";
          setEscrowWalletBalance(bal);
          setEscrowWalletCurrency(cur);
          setEscrowWalletLoading(false);
        })
        .catch(() => setEscrowWalletLoading(false));
    } else {
      setEscrowWalletLoading(false);
    }

    // Check localStorage flags
    if (localStorage.getItem("isSignupModalOpen") == "true") {
      setShowAddAddressModalforsignup(true);
      localStorage.setItem("isSignupModalOpen", "false");
    }

    if (localStorage.getItem("isPaybitoSignInModalOpen") == "true") {
      setShowAddAddressModal(true);
      localStorage.setItem("isPaybitoSignInModalOpen", "false");
      showToast("error", "User is blocked");
    }

    if (localStorage.getItem("isForgetPasswordModalOpen") == "true") {
      setPaybitoResetPswdModal(true);
      localStorage.setItem("isForgetPasswordModalOpen", "false");
    }

    if (localStorage.getItem("isPaybitoResetPswdModalOpen") == "true") {
      setShowAddAddressModal(true);
      localStorage.setItem("isPaybitoResetPswdModalOpen", "false");
    }

    if (localStorage.getItem("isSignInModalOpen") == "true") {
      setShowAddAddressModal(true);
      localStorage.setItem("isSignInModalOpen", "false");
    }

    // Timer restorations
    if (localStorage.getItem("secondStatusCheck") == "true") {
      startTimer(localStorage.getItem("countdownsec"));
      setSecondStatusCheck(true);
      setIsTimerStartForPaybitoGetCode(true);
      setTimer(localStorage.getItem("countdownsec"));
    }

    if (localStorage.getItem("isSecondStatusCheck") == "true") {
      startGetCodeTimer(localStorage.getItem("externalWalletCountdownsec"));
      setIsSecondStatusCheck(true);
      setIsTimerStartForExternalWalletGetCode(true);
      setGetCodeTimer(localStorage.getItem("externalWalletCountdownsec"));
    }

    if (localStorage.getItem("isSecondStatusMobileCheck") == "true") {
      startSmsAuthTimer(localStorage.getItem("smsCodeCountdownsec"));
      setIsSecondStatusMobileCheck(true);
      setIsTimerStartForSmsGetCode(true);
      setGetCodeSmsTimer(localStorage.getItem("smsCodeCountdownsec"));
    }

    if (localStorage.getItem("resendOtpSecondStatus") == "true") {
      startResendOtpTimer(localStorage.getItem("resendOtpCountdown"));
      setResendOtpSecondStatus(true);
      setIsResendOtpTimerStart(true);
      setResendOtpTimerTxt(localStorage.getItem("resendOtpCountdown"));
    }
  }, [
    handleRenderLedgerAmount,
    startTimer,
    startGetCodeTimer,
    startSmsAuthTimer,
    startResendOtpTimer,
  ]);

  useEffect(() => {
    fetchEscrowContracts(escrowContractsPage);
  }, [escrowContractsPage, fetchEscrowContracts]);

  return (
    <Fragment>
      <script
        src="https://www.google.com/recaptcha/api.js"
        async
        defer
      ></script>
      <div className="container-scroller">
        <Sidebar />
        <Header />
        <div className="main-panel">
          <div style={styles.pageWrapper}>
            <PageHeader
              icon="mdi-wallet-outline"
              title="Settlement Wallets"
              subtitle="Manage your crypto assets and transactions"
            >
              {!isTestMode && (
                <button
                  type="button"
                  style={{
                    marginLeft: "auto",
                    padding: "10px 22px",
                    background: "var(--btn-color)",
                    color: "#fff",
                    borderRadius: "10px",
                    fontSize: "13px",
                    fontWeight: "600",
                    border: "none",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                  onClick={() =>
                    (window.location.href = "/automate-withdrawls")
                  }
                >
                  <i className="mdi mdi-autorenew" />
                  Automatic Withdrawal
                </button>
              )}
            </PageHeader>

            {/* Assets Cards */}
            {assets.length === 0 && (
              <div style={styles.card}>
                <div style={styles.emptyState}>
                  <div style={styles.emptyIcon}>
                    <i className="fa fa-wallet"></i>
                  </div>
                  <div style={{ fontSize: "14px" }}>No assets found</div>
                </div>
              </div>
            )}

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
                gap: "20px",
                marginBottom: "28px",
              }}
            >
              {assets
                .filter(
                  (iter) =>
                    !(iter.currency_type === "1" && iter.coinBalance === "0")
                )
                .map((iter) => (
                  <div
                    key={iter.assetId}
                    style={{
                      background: "var(--body-color-less)",
                      borderRadius: "16px",
                      border: "1px solid var(--body-color-less2)",
                      boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
                      padding: "24px",
                      display: "flex",
                      flexDirection: "column",
                      transition: "box-shadow 0.2s, border-color 0.2s",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "14px",
                        marginBottom: "20px",
                      }}
                    >
                      <div
                        style={{
                          width: "48px",
                          height: "48px",
                          borderRadius: "14px",
                          background: "var(--body-color)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                          border: "1px solid var(--body-color-less2)",
                        }}
                      >
                        <img
                          src={iter.assetImage}
                          style={{
                            width: "30px",
                            height: "30px",
                            borderRadius: "50%",
                          }}
                          alt={iter.assetCode}
                        />
                      </div>
                      <div>
                        <div
                          style={{
                            fontWeight: "700",
                            fontSize: "15px",
                            color: "var(--text-color)",
                            lineHeight: "1.2",
                          }}
                        >
                          {iter.assetName}
                        </div>
                        <div
                          style={{
                            fontSize: "12px",
                            fontWeight: "600",
                            opacity: 0.45,
                            color: "var(--text-color)",
                            marginTop: "2px",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          {iter.assetCode}
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        background: "var(--body-color)",
                        borderRadius: "12px",
                        padding: "16px 18px",
                        marginBottom: "18px",
                        border: "1px solid var(--body-color-less2)",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "11px",
                          fontWeight: "600",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                          opacity: 0.45,
                          color: "var(--text-color)",
                          marginBottom: "6px",
                        }}
                      >
                        Balance
                      </div>
                      <div
                        style={{
                          fontFamily:
                            "'SF Mono', 'Fira Code', 'Fira Mono', 'Roboto Mono', monospace",
                          fontWeight: "700",
                          fontSize: "20px",
                          color: "var(--text-color)",
                          lineHeight: "1.2",
                        }}
                      >
                        {iter.coinBalance}
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          opacity: 0.5,
                          color: "var(--text-color)",
                          marginTop: "2px",
                        }}
                      >
                        {iter.assetCode}
                      </div>
                    </div>

                    <button
                      type="button"
                      style={{
                        width: "100%",
                        padding: "12px 24px",
                        background:
                          iter.currency_type === "1"
                            ? "var(--body-color-less2)"
                            : "var(--btn-color)",
                        color: "#fff",
                        borderRadius: "12px",
                        fontSize: "14px",
                        fontWeight: "600",
                        border: "none",
                        cursor:
                          iter.currency_type === "1"
                            ? "not-allowed"
                            : permission == "WRITE"
                            ? "pointer"
                            : "not-allowed",
                        opacity:
                          iter.currency_type === "1"
                            ? 0.6
                            : permission == "WRITE"
                            ? 1
                            : 0.5,
                        transition: "opacity 0.2s",
                        marginTop: "auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                      }}
                      disabled={
                        iter.currency_type === "1" || permission != "WRITE"
                      }
                      onClick={() => {
                        if (iter.currency_type !== "1") {
                          handleCriptoWithdraw(iter);
                        }
                      }}
                    >
                      <i
                        className="fa fa-arrow-up"
                        style={{ fontSize: "12px" }}
                      ></i>
                      {iter.currency_type === "1"
                        ? "Withdraw via your processor"
                        : "Withdraw"}
                    </button>
                  </div>
                ))}
            </div>

            {/* Escrow Wallet Section */}
            {(() => {
              const ESCROW_PAGE_SIZE = 10;
              const totalPages = Math.ceil(escrowContractsTotalRecords / ESCROW_PAGE_SIZE);
              const safePage = escrowContractsPage;
              const pageRows = escrowContracts;
              const currency = escrowWalletCurrency || localStorage.getItem(SITENAMEALIAS + "_home_currency") || "USD";
              return (
                <div
                  style={{
                    ...styles.card,
                    borderTop: "3px solid #10b981",
                    marginBottom: "28px",
                    padding: "28px 0 0",
                  }}
                >
                  <div style={{ ...styles.cardHeaderRow, padding: "0 32px", marginBottom: "20px" }}>
                    <div style={{ ...styles.cardHeaderIcon, ...styles.iconGreen }}>
                      <i className="fa fa-lock"></i>
                    </div>
                    <div>
                      <div style={styles.cardTitle}>Escrow Wallet</div>
                      <div style={styles.cardSubtitle}>
                        Released escrow contracts available for withdrawal
                      </div>
                    </div>
                  </div>

                  {escrowContractsLoading ? (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "28px 0",
                        fontSize: "13px",
                        color: "var(--text-color)",
                        opacity: 0.5,
                      }}
                    >
                      <i className="fa fa-spinner fa-spin" style={{ marginRight: "8px" }}></i>
                      Loading…
                    </div>
                  ) : (
                    <>
                      <div style={{ overflowX: "auto" }}>
                        <table style={{ ...styles.table }}>
                          <thead>
                            <tr>
                              {["Contract No", "Contract Name", "Amount", "Created At", "Action"].map((h) => (
                                <th
                                  key={h}
                                  style={{
                                    ...styles.th,
                                    color: "#10b981",
                                    background: "linear-gradient(135deg, color-mix(in srgb, #10b981 6%, transparent), color-mix(in srgb, #10b981 2%, transparent))",
                                    borderBottom: "2px solid color-mix(in srgb, #10b981 20%, transparent)",
                                    textAlign: h === "Action" ? "center" : "left",
                                  }}
                                >
                                  {h}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {pageRows.length === 0 ? (
                              <tr>
                                <td colSpan={5} style={{ ...styles.td, textAlign: "center", opacity: 0.5, padding: "32px 0" }}>
                                  No escrow contracts available.
                                </td>
                              </tr>
                            ) : (
                              pageRows.map((row, idx) => (
                                <tr
                                  key={row.CONTRACT_NO}
                                  style={{
                                    background: idx % 2 === 0
                                      ? "transparent"
                                      : "color-mix(in srgb, var(--body-color-less2) 25%, transparent)",
                                  }}
                                >
                                  <td style={{ ...styles.td }}>
                                    <span
                                      style={{ fontFamily: "'SF Mono','Fira Code','Roboto Mono',monospace", fontWeight: 600, fontSize: 13, color: "#10b981", cursor: "pointer", textDecoration: "underline" }}
                                      onClick={() => history.push(`/escrow/payee/contract/${row.CONTRACT_NO}`)}
                                    >
                                      {row.CONTRACT_NO}
                                    </span>
                                  </td>
                                  <td style={{ ...styles.td, fontWeight: 600 }}>{row.CONTRACT_NAME}</td>
                                  <td style={{ ...styles.td }}>
                                    <span style={{ ...styles.balanceText }}>
                                      {Number(row.AMOUNT).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 6 })}
                                    </span>
                                    <span style={{ fontSize: 11, opacity: 0.5, marginLeft: 5 }}>{currency}</span>
                                  </td>
                                  <td style={{ ...styles.td, opacity: 0.7, fontSize: 13 }}>
                                    {new Date(row.CREATED_AT).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" })}
                                  </td>
                                  <td style={{ ...styles.td, textAlign: "center" }}>
                                    {(row.STATUS || "").toUpperCase() === "DISPUTED" && Number(row.IS_REFUNDED) === 0 ? (
                                      <span
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: 6,
                                          padding: "5px 14px",
                                          borderRadius: 20,
                                          fontSize: 12,
                                          fontWeight: 600,
                                          background: "rgba(139,92,246,0.12)",
                                          color: "#a78bfa",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#a78bfa", display: "inline-block", flexShrink: 0 }} />
                                        Disputed
                                      </span>
                                    ) : (
                                      <button
                                        type="button"
                                        style={{
                                          ...styles.btnPrimary,
                                          background: "#10b981",
                                          boxShadow: "0 2px 8px rgba(16,185,129,0.25)",
                                          padding: "7px 18px",
                                          fontSize: 12,
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: 6,
                                        }}
                                        onClick={() => {
                                          setEscrowWalletBalance(row.AMOUNT);
                                          setEscrowWalletCurrency(currency);
                                          setEscrowWithdrawContractNo(row.CONTRACT_NO);
                                          setIsEscrowWithdraw(true);
                                          setEscrowWithdrawTerms(false);
                                          setEscrowBrandAmount("");
                                          setEscrowBrandAmountError("");
                                          if (homeCurrencyId) {
                                            getFeesByCurrencyId({
                                              currencyId: homeCurrencyId,
                                              merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
                                            })
                                              .then((res) => {
                                                const d = res.data[0];
                                                setMinFee(d.MIN_FEE);
                                                setFromFee(d.FROMFEE);
                                                setToFee(d.TOFEE);
                                                setFeeRate(d.FEE_RATE);
                                                setCurrencyPrecision(d.CURRENCY_PRECISION);
                                                setEscrowWithdrawStep("brand");
                                              })
                                              .catch(() => {
                                                setEscrowWithdrawStep("brand");
                                              });
                                          } else {
                                            setEscrowWithdrawStep("brand");
                                          }
                                        }}
                                      >
                                        <i className="fa fa-arrow-up" style={{ fontSize: 11 }}></i>
                                        Withdraw
                                      </button>
                                    )}
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>

                      {/* Pagination */}
                      {totalPages > 1 && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "14px 24px",
                            borderTop: "1px solid color-mix(in srgb, var(--body-color-less2) 60%, transparent)",
                          }}
                        >
                          <span style={{ fontSize: 12, opacity: 0.55 }}>
                            Showing {(safePage - 1) * ESCROW_PAGE_SIZE + 1}–{Math.min(safePage * ESCROW_PAGE_SIZE, escrowContractsTotalRecords)} of {escrowContractsTotalRecords}
                          </span>
                          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                            <button
                              style={{
                                ...styles.btnSecondary,
                                padding: "5px 12px",
                                fontSize: 12,
                                opacity: safePage === 1 ? 0.4 : 1,
                                cursor: safePage === 1 ? "not-allowed" : "pointer",
                              }}
                              disabled={safePage === 1}
                              onClick={() => setEscrowContractsPage((p) => p - 1)}
                            >
                              <i className="fa fa-chevron-left"></i>
                            </button>
                            {Array.from({ length: totalPages }, (_, i) => i + 1).map((pg) => (
                              <button
                                key={pg}
                                style={{
                                  padding: "5px 10px",
                                  fontSize: 12,
                                  fontWeight: 600,
                                  borderRadius: 8,
                                  border: "1px solid",
                                  cursor: "pointer",
                                  borderColor: pg === safePage ? "#10b981" : "var(--body-color-less2)",
                                  background: pg === safePage ? "#10b981" : "transparent",
                                  color: pg === safePage ? "#fff" : "var(--text-color)",
                                  minWidth: 32,
                                }}
                                onClick={() => setEscrowContractsPage(pg)}
                              >
                                {pg}
                              </button>
                            ))}
                            <button
                              style={{
                                ...styles.btnSecondary,
                                padding: "5px 12px",
                                fontSize: 12,
                                opacity: safePage === totalPages ? 0.4 : 1,
                                cursor: safePage === totalPages ? "not-allowed" : "pointer",
                              }}
                              disabled={safePage === totalPages}
                              onClick={() => setEscrowContractsPage((p) => p + 1)}
                            >
                              <i className="fa fa-chevron-right"></i>
                            </button>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              );
            })()}

            {/* User Transactions Card */}
            <div
              style={{
                ...styles.card,
                borderTop: "3px solid #8b5cf6",
                background: "var(--body-color-less)",
                position: "relative",
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: "120px",
                  background:
                    "linear-gradient(180deg, color-mix(in srgb, #8b5cf6 4%, transparent), transparent)",
                  pointerEvents: "none",
                }}
              />

              <div
                style={{
                  ...styles.cardHeaderRow,
                  position: "relative",
                  zIndex: 1,
                }}
              >
                <div
                  style={{
                    ...styles.cardHeaderIcon,
                    ...styles.iconPurple,
                    width: "42px",
                    height: "42px",
                    borderRadius: "12px",
                    fontSize: "18px",
                    boxShadow:
                      "0 4px 12px color-mix(in srgb, #8b5cf6 20%, transparent)",
                  }}
                >
                  <i className="fa fa-exchange-alt"></i>
                </div>
                <div style={{ flex: 1 }}>
                  <h5
                    style={{
                      ...styles.cardTitle,
                      fontSize: "18px",
                      letterSpacing: "-0.3px",
                    }}
                  >
                    User Transactions
                  </h5>
                  <div
                    style={{
                      ...styles.cardSubtitle,
                      fontSize: "13px",
                      marginTop: "3px",
                    }}
                  >
                    {totalCount > 0
                      ? `${totalCount} total transactions`
                      : "Recent activity"}
                  </div>
                </div>
                {totalCount > 0 && (
                  <div
                    style={{
                      background: "linear-gradient(135deg, #8b5cf6, #7c3aed)",
                      color: "#fff",
                      padding: "6px 14px",
                      borderRadius: "20px",
                      fontSize: "12px",
                      fontWeight: "700",
                      letterSpacing: "0.3px",
                      boxShadow:
                        "0 2px 8px color-mix(in srgb, #8b5cf6 25%, transparent)",
                    }}
                  >
                    {totalCount}
                  </div>
                )}
              </div>

              <div
                style={{
                  overflowX: "auto",
                  overflowY: "hidden",
                  WebkitOverflowScrolling: "touch",
                  borderRadius: "12px",
                  border:
                    "1px solid color-mix(in srgb, #8b5cf6 10%, var(--body-color-less2))",
                  position: "relative",
                  zIndex: 1,
                }}
              >
                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th style={{ ...styles.th, borderRadius: "12px 0 0 0" }}>
                        Txn ID
                      </th>
                      <th style={styles.th}>Timestamp</th>
                      <th style={styles.th}>Description</th>
                      <th style={styles.th}>Withdrawal Type</th>
                      <th style={styles.th}>Amount</th>
                      <th style={styles.th}>Asset</th>
                      <th
                        style={{
                          ...styles.th,
                          textAlign: "center",
                          borderRadius: "0 12px 0 0",
                        }}
                      >
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {userTransactionList.length == 0 && (
                      <tr>
                        <td
                          colSpan={7}
                          style={{ ...styles.td, borderBottom: "none" }}
                        >
                          <div style={styles.emptyState}>
                            <div style={styles.emptyIcon}>
                              <i className="fa fa-receipt"></i>
                            </div>
                            <div
                              style={{
                                fontSize: "15px",
                                fontWeight: "600",
                                marginBottom: "6px",
                              }}
                            >
                              No Transactions Yet
                            </div>
                            <div style={{ fontSize: "13px", opacity: 0.5 }}>
                              Your transaction history will appear here
                            </div>
                          </div>
                        </td>
                      </tr>
                    )}
                    {userTransactionList.length != 0 &&
                      userTransactionList.map((iter, index) => (
                        <tr
                          key={iter.transaction_id}
                          style={{
                            background:
                              index % 2 === 0
                                ? "transparent"
                                : "color-mix(in srgb, #8b5cf6 2%, transparent)",
                          }}
                        >
                          <td
                            style={{
                              ...styles.td,
                              fontFamily: "'SF Mono', 'Fira Code', monospace",
                              fontSize: "13px",
                              color: "#8b5cf6",
                              fontWeight: "500",
                            }}
                          >
                            {iter.transaction_id}
                          </td>
                          <td
                            style={{
                              ...styles.td,
                              fontSize: "13px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <i
                                className="fa fa-clock"
                                style={{ fontSize: "11px", opacity: 0.4 }}
                              ></i>
                              <Moment
                                format="MMM D, YYYY h:mm a"
                                date={iter.transaction_timestamp}
                              />
                            </div>
                          </td>
                          <td style={{ ...styles.td, maxWidth: "200px" }}>
                            <div
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {iter.description}
                            </div>
                          </td>
                          <td style={{ ...styles.td }}>
                            {iter.withdrawalType || "-"}
                          </td>
                          <td
                            style={{
                              ...styles.td,
                              ...styles.balanceText,
                              color:
                                iter.debit_amount > 0
                                  ? "#10b981"
                                  : "var(--text-color)",
                            }}
                          >
                            {formatAmount(iter.debit_amount, 5)}
                          </td>
                          <td style={{ ...styles.td }}>
                            <span
                              style={{
                                fontWeight: "700",
                                fontSize: "13px",
                                background:
                                  "linear-gradient(135deg, color-mix(in srgb, #8b5cf6 10%, transparent), color-mix(in srgb, #8b5cf6 4%, transparent))",
                                padding: "4px 10px",
                                borderRadius: "6px",
                                border:
                                  "1px solid color-mix(in srgb, #8b5cf6 12%, transparent)",
                              }}
                            >
                              {iter.name}
                            </span>
                          </td>
                          <td style={{ ...styles.td, textAlign: "center" }}>
                            <span
                              style={{
                                ...styles.statusBadge,
                                ...(iter.status == "Pending"
                                  ? styles.statusPending
                                  : iter.status == "Confirmed"
                                  ? styles.statusConfirmed
                                  : styles.statusFailed),
                              }}
                            >
                              <span
                                style={{
                                  ...styles.statusDot,
                                  background:
                                    iter.status == "Pending"
                                      ? "#f59e0b"
                                      : iter.status == "Confirmed"
                                      ? "#10b981"
                                      : "#ef4444",
                                }}
                              />
                              {iter.status}
                            </span>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>

              {userTransactionList.length != 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "8px",
                    marginTop: "28px",
                    flexWrap: "wrap",
                    position: "relative",
                    zIndex: 1,
                  }}
                >
                  {pageList.map((page) => (
                    <button
                      type="button"
                      key={page}
                      style={{
                        ...styles.paginationBtn,
                        ...(pageNo == page ? styles.paginationActive : {}),
                      }}
                      onMouseEnter={(e) => {
                        if (pageNo != page) {
                          e.currentTarget.style.borderColor = "#8b5cf6";
                          e.currentTarget.style.color = "#8b5cf6";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (pageNo != page) {
                          e.currentTarget.style.borderColor =
                            "var(--body-color-less2)";
                          e.currentTarget.style.color = "var(--text-color)";
                        }
                      }}
                      onClick={() => {
                        setPageNo(page);
                        renderUserTransactions();
                      }}
                    >
                      {page}
                    </button>
                  ))}
                </div>
              )}
            </div>
          </div>
          <Footer />
        </div>

        {/* OTP Verification Modal */}
        <Modal
          show={showPaybitoOtpModal}
          backdrop="static"
          keyboard={false}
          centered
        >
          <div style={styles.modalOverlay}>
            <div style={styles.modalHeader}>
              <div style={{ ...styles.cardHeaderIcon, ...styles.iconBlue }}>
                <i className="fa fa-shield-alt"></i>
              </div>
              <div style={styles.modalTitle}>OTP Verification</div>
            </div>
            <div style={styles.modalBody}>
              <form onSubmit={(e) => e.preventDefault()}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Enter OTP</label>
                  <div style={{ position: "relative" }}>
                    <input
                      type="text"
                      style={styles.input}
                      value={paybitoOtp}
                      onChange={isPaybitoOtpValid}
                      placeholder="Enter OTP"
                    />
                    {!isTimerStartForPaybitoGetCode && (
                      <span
                        style={styles.getCodeBtn}
                        onClick={sendVerificationMail}
                      >
                        Get OTP
                      </span>
                    )}
                  </div>
                  {isTimerStartForPaybitoGetCode && (
                    <div style={styles.timerText}>Resend OTP in {timer}</div>
                  )}
                </div>
                <div style={styles.modalFooter}>
                  <button
                    type="button"
                    style={{
                      ...styles.btnPrimary,
                      opacity: !isButtonDisable ? 0.5 : 1,
                    }}
                    onClick={loginPaybito}
                    disabled={!isButtonDisable}
                  >
                    Login
                  </button>
                  <button
                    type="button"
                    style={styles.btnSecondary}
                    onClick={() => {
                      setShowPaybitoOtpModal(false);
                      setShowLoader(true);
                      localStorage.setItem("countdownsec", "");
                      handleRenderLedgerAmount();
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Modal>

        {/* SMS Authentication Modal */}
        <Modal
          show={showPaybitoMobileSmsAuthModal}
          backdrop="static"
          keyboard={false}
          centered
        >
          <div style={styles.modalOverlay}>
            <div style={styles.modalHeader}>
              <div style={{ ...styles.cardHeaderIcon, ...styles.iconGreen }}>
                <i className="fa fa-mobile-alt"></i>
              </div>
              <div style={styles.modalTitle}>SMS Authentication</div>
            </div>
            <div style={styles.modalBody}>
              <form onSubmit={(e) => e.preventDefault()}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>
                    Input OTP from your registered mobile number
                  </label>
                  <input
                    type="text"
                    style={styles.input}
                    ref={smsOtpRef}
                    value={smsAuthOtp}
                    onChange={(e) => {
                      setSmsAuthOtp(e.target.value);
                      setIsButtonDisable(!isButtonDisable);
                    }}
                    placeholder="Enter SMS OTP"
                  />
                </div>
                <div style={styles.modalFooter}>
                  <button
                    type="button"
                    style={styles.btnPrimary}
                    onClick={paybitoMobileSmsVerify}
                  >
                    Confirm
                  </button>
                  <button
                    type="button"
                    style={styles.btnSecondary}
                    onClick={() => {
                      setShowPaybitoMobileSmsAuthModal(false);
                      setSmsAuthOtp("");
                      handleRenderLedgerAmount();
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Modal>

        {/* Paybito Login Modal */}
        <Modal
          show={showAddAddressModal}
          backdrop="static"
          keyboard={false}
          centered
        >
          <div style={styles.modalOverlay}>
            <div style={styles.modalHeader}>
              <div style={{ ...styles.cardHeaderIcon, ...styles.iconBlue }}>
                <i className="fa fa-sign-in-alt"></i>
              </div>
              <div style={styles.modalTitle}>
                Sign in to {localStorage.getItem(SITENAMEALIAS + "_exchange")}
              </div>
            </div>
            <div style={styles.modalBody}>
              <div id="paybitosignin">
                <form
                  onSubmit={(event) => {
                    event.preventDefault();
                    paybitoOtpModal(event);
                  }}
                >
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Email Address</label>
                    <input
                      type="email"
                      style={styles.input}
                      id="paybitoLoginEmail1"
                      value={paybitoemail}
                      onChange={(e) => setPaybitoemail(e.target.value)}
                      placeholder="Enter your email"
                    />
                  </div>
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Password</label>
                    <div style={{ position: "relative" }}>
                      <input
                        type={password}
                        style={{ ...styles.input, paddingRight: "42px" }}
                        id="paybitoLoginPswd"
                        value={paybitopswd}
                        onChange={(e) => setPaybitopswd(e.target.value)}
                        placeholder="Enter your password"
                      />
                      <span style={styles.inputGroupAppend} onClick={Eye}>
                        <i
                          className={`fa ${eye ? "fa-eye-slash" : "fa-eye"}`}
                        ></i>
                      </span>
                    </div>
                  </div>
                  <div style={styles.modalFooter}>
                    <button type="submit" style={styles.btnPrimary}>
                      Next
                    </button>
                    <button
                      type="button"
                      style={styles.btnSecondary}
                      onClick={() => {
                        setShowAddAddressModal(false);
                        setShowLoader(true);
                        handleRenderLedgerAmount();
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
                <CaptchaModal
                  setState={setStateHandler}
                  showCaptchaModal={showCaptchaModal}
                  handleCaptchaSubmit={handleCaptchaSubmit}
                />
                <div
                  style={{
                    marginTop: "20px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <a
                    href="javascript:void(0)"
                    style={styles.linkText}
                    onClick={() => {
                      setPaybitoForgetPswdModal(true);
                      setShowAddAddressModal(false);
                    }}
                  >
                    Forgot Password?
                  </a>
                  <span
                    style={{
                      fontSize: "13px",
                      color: "var(--text-color)",
                      opacity: 0.7,
                    }}
                  >
                    New user?{" "}
                    <a
                      href="javascript:void(0)"
                      style={styles.linkText}
                      onClick={() => {
                        window.open(signUppage, "_blank");
                      }}
                    >
                      Sign up
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        {/* Paybito Signup Modal */}
        <Modal
          show={showAddAddressModalforsignup}
          backdrop="static"
          keyboard={false}
          centered
        >
          <div style={styles.modalOverlay}>
            <div style={styles.modalHeader}>
              <div style={{ ...styles.cardHeaderIcon, ...styles.iconGreen }}>
                <i className="fa fa-user-plus"></i>
              </div>
              <div style={styles.modalTitle}>
                Sign Up to {localStorage.getItem(SITENAMEALIAS + "_exchange")}
              </div>
            </div>
            <div style={styles.modalBody}>
              <form onSubmit={(e) => e.preventDefault()}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>First Name</label>
                  <input
                    type="text"
                    style={styles.input}
                    id="exampleInputFName"
                    ref={signupFirstNameRef}
                    placeholder="Enter First Name"
                  />
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: "14px",
                  }}
                >
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Middle Name</label>
                    <input
                      type="text"
                      style={styles.input}
                      id="exampleInputmiddleName"
                      ref={signupMiddleNameRef}
                      placeholder="Enter Middle Name"
                    />
                  </div>
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Last Name</label>
                    <input
                      type="text"
                      style={styles.input}
                      id="exampleInputLName"
                      ref={signupLastNameRef}
                      placeholder="Enter Last Name"
                    />
                  </div>
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Email</label>
                  <input
                    type="email"
                    style={styles.input}
                    id="exampleInputEmail"
                    onBlur={handleEmail}
                    ref={signupEmailRef}
                    placeholder="Enter Email"
                  />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Phone No</label>
                  <PhoneInput
                    country={"us"}
                    ref={signupPhoneRef}
                    onBlur={(phone) => handlePhone(phone)}
                    inputStyle={{
                      width: "100%",
                      padding: "10px 14px 10px 48px",
                      fontSize: "14px",
                      borderRadius: "10px",
                      border: "1px solid var(--body-color-less2)",
                      background: "var(--body-color)",
                      color: "var(--text-color)",
                    }}
                    inputProps={{ autoFormat: false, placeholder: null }}
                    onChange={(value) => {
                      if (value.length <= 8) {
                        setPhoneErrorMsg(true);
                      } else if (value.length >= 15) {
                        setPhoneErrorMsg(true);
                      } else {
                        setPhoneErrorMsg(false);
                      }
                    }}
                  />
                  {phoneErrorMsg ? (
                    <div style={{ ...styles.passwordHint, marginTop: "6px" }}>
                      Enter a valid phone number
                    </div>
                  ) : null}
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>
                    Membership ID / Broker ID
                    <span
                      style={{
                        marginLeft: "8px",
                        cursor: "pointer",
                        opacity: 0.5,
                      }}
                      onClick={() => setBrokerIdInfoModal(!brokerIdInfoModal)}
                    >
                      <i className="fa fa-info-circle"></i>
                    </span>
                  </label>
                  {brokerIdInfoModal ? (
                    <div
                      style={{
                        ...styles.infoBox,
                        marginBottom: "8px",
                        fontSize: "12px",
                      }}
                    >
                      {localStorage.getItem(SITENAMEALIAS + "_exchange")} Broker
                      / Membership ID is{" "}
                      {localStorage.getItem(SITENAMEALIAS + "_brokerId")}.
                      Please use this or the one provided by your Broker.
                    </div>
                  ) : null}
                  <input
                    type="text"
                    style={styles.input}
                    id="brokeridPaybito"
                    ref={brokeridpaybitoRef}
                    placeholder="Enter membership ID / Broker ID"
                  />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Password</label>
                  <div style={{ position: "relative" }}>
                    <input
                      type={passwordType ? "text" : "password"}
                      style={{ ...styles.input, paddingRight: "42px" }}
                      id="signupPasswordRef"
                      onKeyUp={handleMatchPassword}
                      ref={signupPasswordRef}
                      placeholder="Enter Password"
                    />
                    <span
                      style={styles.inputGroupAppend}
                      onClick={() => {
                        setIsActive(!isActive);
                        setPasswordType(!passwordType);
                      }}
                    >
                      <i
                        className={isActive ? "fa fa-eye" : "fa fa-eye-slash"}
                      ></i>
                    </span>
                  </div>
                  {isPasswordValid ? (
                    <div style={styles.passwordHint}>
                      The password should be of minimum 8, maximum 35 characters
                      and must contain at least one uppercase, one lowercase, a
                      number and a special character (only $ @ . ! are allowed).
                    </div>
                  ) : null}
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Retype Password</label>
                  <input
                    type="password"
                    style={styles.input}
                    id="signupRePasswordRef"
                    onKeyUp={handleMatchPassword}
                    ref={signupRePasswordRef}
                    placeholder="Retype Password"
                  />
                  <div
                    style={{
                      ...styles.matchText,
                      color: isPasswordMatched ? "#10b981" : "#ef4444",
                    }}
                  >
                    {isPasswordMatched
                      ? "Password Matched"
                      : "Password Mismatched"}
                  </div>
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Referral Code (optional)</label>
                  <input
                    type="text"
                    style={styles.input}
                    id="referralCodePaybito"
                    placeholder="Enter referral code"
                  />
                </div>
                <div style={styles.modalFooter}>
                  <button
                    type="button"
                    style={styles.btnPrimary}
                    onClick={handleSignuptoPaybito}
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    style={styles.btnSecondary}
                    onClick={() => setShowAddAddressModalforsignup(false)}
                  >
                    Cancel
                  </button>
                </div>
                <CaptchaModal
                  setState={setStateHandler}
                  showCaptchaModal={showCaptchaModalSecond}
                  handleCaptchaSubmit={handleCaptchaSubmitSecond}
                />
                <div
                  style={{
                    textAlign: "center",
                    marginTop: "16px",
                    fontSize: "13px",
                    color: "var(--text-color)",
                    opacity: 0.7,
                  }}
                >
                  <div>
                    By registering you are agreeing to the{" "}
                    <a
                      href={
                        localStorage.getItem(SITENAMEALIAS + "_brokerDomain") +
                        "/terms-condition"
                      }
                      target="_blank"
                      style={styles.linkText}
                    >
                      terms of use
                    </a>
                  </div>
                  <div style={{ marginTop: "6px" }}>
                    Already a member?{" "}
                    <a
                      href="javascript:void(0)"
                      style={styles.linkText}
                      onClick={() => {
                        localStorage.setItem("isSignInModalOpen", "true");
                        setShowAddAddressModal(true);
                        setShowAddAddressModalforsignup(false);
                      }}
                    >
                      Sign in
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Modal>

        {/* Forgot Password / Secure Token Modal */}
        <Modal
          show={paybitoForgetPswdModal}
          backdrop="static"
          keyboard={false}
          centered
        >
          <div style={styles.modalOverlay}>
            <div style={styles.modalHeader}>
              <div style={{ ...styles.cardHeaderIcon, ...styles.iconAmber }}>
                <i className="fa fa-key"></i>
              </div>
              <div style={styles.modalTitle}>
                {localStorage.getItem(SITENAMEALIAS + "_exchange")} Secure-Token
              </div>
            </div>
            <div style={styles.modalBody}>
              <form onSubmit={(e) => e.preventDefault()}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Email Address</label>
                  <div
                    style={{
                      fontSize: "12px",
                      opacity: 0.6,
                      marginBottom: "8px",
                    }}
                  >
                    Enter the email address registered with{" "}
                    {localStorage.getItem(SITENAMEALIAS + "_exchange")}
                  </div>
                  <input
                    type="text"
                    style={styles.input}
                    id="paybitoForgotPswd"
                    ref={paybitoForgetPasswordInput}
                    placeholder="Email"
                  />
                </div>
                <button
                  type="button"
                  style={{ ...styles.btnPrimary, width: "100%" }}
                  onClick={handleForgotPasswordPaybito}
                >
                  Get Secure Token
                </button>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "16px",
                  }}
                >
                  <a
                    href="javascript:void(0)"
                    style={styles.linkText}
                    onClick={() => {
                      setShowAddAddressModalforsignup(true);
                      setPaybitoForgetPswdModal(false);
                    }}
                  >
                    Create an account
                  </a>
                  <a
                    href="javascript:void(0)"
                    style={styles.linkText}
                    onClick={() => {
                      setShowAddAddressModal(true);
                      setPaybitoForgetPswdModal(false);
                    }}
                  >
                    Back to Sign In
                  </a>
                </div>
              </form>
            </div>
          </div>
        </Modal>

        {/* Reset Password Modal */}
        <Modal
          show={paybitoResetPswdModal}
          backdrop="static"
          keyboard={false}
          centered
        >
          <div style={styles.modalOverlay}>
            <div style={styles.modalHeader}>
              <div style={{ ...styles.cardHeaderIcon, ...styles.iconAmber }}>
                <i className="fa fa-lock"></i>
              </div>
              <div style={styles.modalTitle}>
                {localStorage.getItem(SITENAMEALIAS + "_exchange")}{" "}
                Forgot-Password
              </div>
            </div>
            <div style={styles.modalBody}>
              <form onSubmit={(e) => e.preventDefault()}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Email*</label>
                  <input
                    type="text"
                    style={styles.input}
                    id="paybitoForgotPswd"
                    ref={forgotPswdInputEmail}
                  />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>New Password*</label>
                  <div style={{ position: "relative" }}>
                    <input
                      type={passwordType ? "text" : "password"}
                      style={{ ...styles.input, paddingRight: "42px" }}
                      id="paybitoNewPswd"
                      ref={newPswdInputEmail}
                      onKeyUp={validatePassword}
                    />
                    <span
                      style={styles.inputGroupAppend}
                      onClick={() => {
                        setIsActive(!isActive);
                        setPasswordType(!passwordType);
                      }}
                    >
                      <i
                        className={isActive ? "fa fa-eye" : "fa fa-eye-slash"}
                      ></i>
                    </span>
                  </div>
                  {pswdnotmatched ? (
                    <div style={styles.passwordHint}>
                      The password should be of minimum 8, maximum 35 characters
                      and must contain at least one uppercase, one lowercase, a
                      number and a special character (only $ @ . ! are allowed).
                    </div>
                  ) : null}
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Retype New Password*</label>
                  <input
                    type="text"
                    style={styles.input}
                    id="paybitoNewPswd"
                    ref={retypePswdInputEmail}
                    onKeyUp={passwordMatched}
                  />
                  <div
                    style={{
                      ...styles.matchText,
                      color: isPasswordMatched ? "#10b981" : "#ef4444",
                    }}
                  >
                    {isPasswordMatched
                      ? "Password Matched"
                      : "Password Mismatched"}
                  </div>
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Secure Token*</label>
                  <input
                    type="text"
                    style={styles.input}
                    id="paybitoSecureToken"
                    ref={paybitoInputSecureToken}
                    placeholder="Secure Token"
                  />
                </div>
                <button
                  type="button"
                  style={{ ...styles.btnPrimary, width: "100%" }}
                  onClick={handleResetPasswordPaybito}
                >
                  Change Password
                </button>
                <CaptchaModal
                  setState={setStateHandler}
                  showCaptchaModal={showCaptchaModalThird}
                  handleCaptchaSubmit={handleCaptchaSubmitThird}
                />
                <div style={{ textAlign: "center", marginTop: "16px" }}>
                  <a
                    href="javascript:void(0)"
                    style={styles.linkText}
                    onClick={() => {
                      setPaybitoResetPswdModal(false);
                      setShowAddAddressModalforsignup(true);
                    }}
                  >
                    Create an account
                  </a>
                </div>
              </form>
            </div>
          </div>
        </Modal>

        {/* Balance Transfer Modal */}
        <Modal show={transferModal} backdrop="static" keyboard={false} centered>
          <div style={styles.modalOverlay}>
            <div style={styles.modalHeader}>
              <div style={{ ...styles.cardHeaderIcon, ...styles.iconBlue }}>
                <i className="fa fa-exchange-alt"></i>
              </div>
              <div>
                <div style={styles.modalTitle}>Withdraw your crypto</div>
                <div
                  style={{ fontSize: "12px", opacity: 0.5, marginTop: "2px" }}
                >
                  Transfer balance to{" "}
                  {localStorage.getItem(SITENAMEALIAS + "_exchange")}
                </div>
              </div>
            </div>
            <div style={styles.modalBody}>
              <form onSubmit={(event) => closeTransferModal(event)}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Amount</label>
                  <input
                    type="number"
                    min={0}
                    step="any"
                    style={styles.input}
                    id="Amount"
                    ref={AmountRef}
                    placeholder="Enter amount"
                    value={amount} // 👈 controlled input
                    onChange={(e) => {
                      const value = e.target.value;
                      const maxAmount = parseFloat(toFee);
                      const minAmount = parseFloat(fromFee);

                      if (value === "") {
                        setAmount("");
                        setAmountErrorWallet("");
                        return;
                      }

                      const numericValue = parseFloat(value);

                      // Block update entirely if value exceeds max
                      let error = "";
                      if (
                        !isNaN(numericValue) &&
                        maxAmount &&
                        numericValue > maxAmount
                      ) {
                        error = `Maximum amount is ${toFee}`;
                      }

                      if (
                        !isNaN(numericValue) &&
                        minAmount &&
                        numericValue < minAmount
                      ) {
                        error = `Minimum amount is ${fromFee}`;
                      }

                      setAmount(value);
                      setAmountErrorWallet(error);
                      transferAmt(e); // 👈 call your original handler
                    }}
                  />
                  {amountErrorWallet && (
                    <p style={{ color: "red", fontSize: 12 }}>
                      {amountErrorWallet}
                    </p>
                  )}
                </div>
                <div style={{ ...styles.infoBox, marginBottom: "20px" }}>
                  <i
                    className="fa fa-info-circle"
                    style={{ marginRight: "8px", opacity: 0.7 }}
                  ></i>
                  Minimum of {fromFee} and maximum {toFee} can be sent.
                </div>
                <div style={styles.modalFooter}>
                  <button
                    type="submit"
                    style={{
                      ...styles.btnPrimary,
                      opacity: !amount || amountErrorWallet ? 0.5 : 1,
                    }}
                    disabled={!amount || amountErrorWallet}
                  >
                    Transfer
                  </button>
                  <button
                    type="button"
                    style={styles.btnSecondary}
                    onClick={() => {
                      setTransferModal(false);
                      setAmount("");
                      setShowPaybitoSecurityAuthTranscationModal(false);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Modal>

        {/* Signup OTP Modal */}
        <Modal show={showOtpModal} backdrop="static" keyboard={false} centered>
          <div style={styles.modalOverlay}>
            <div style={styles.modalHeader}>
              <div style={{ ...styles.cardHeaderIcon, ...styles.iconGreen }}>
                <i className="fa fa-check-circle"></i>
              </div>
              <div style={styles.modalTitle}>OTP Verification</div>
            </div>
            <div style={styles.modalBody}>
              <form onSubmit={(e) => e.preventDefault()}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Phone OTP</label>
                  <div
                    style={{
                      fontSize: "12px",
                      opacity: 0.6,
                      marginBottom: "8px",
                    }}
                  >
                    We sent a text message to{" "}
                    {`${signupCountryCodeRef}${signupPhoneNumberRef}`}. Enter
                    the eight digit code to confirm your phone number.
                  </div>
                  <input
                    type="text"
                    style={styles.input}
                    ref={phoneOtpRef}
                    placeholder="Enter OTP from phone"
                  />
                  {isResendPhoneOtpTimerStart ? (
                    <div style={styles.timerText}>
                      Resend In {resendPhoneOtpTimerTxt}
                    </div>
                  ) : (
                    <div style={{ textAlign: "right", marginTop: "6px" }}>
                      <span style={styles.linkText} onClick={handleResendOtp}>
                        Resend OTP
                      </span>
                    </div>
                  )}
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Email OTP</label>
                  <input
                    type="text"
                    style={styles.input}
                    ref={otpRef}
                    placeholder="Enter OTP from email"
                  />
                  {isResendOtpTimerStart ? (
                    <div style={styles.timerText}>
                      Resend In {resendOtpTimerTxt}
                    </div>
                  ) : (
                    <div style={{ textAlign: "right", marginTop: "6px" }}>
                      <span style={styles.linkText} onClick={handleResendOtp}>
                        Resend OTP
                      </span>
                    </div>
                  )}
                </div>
                <div
                  style={{
                    ...styles.warningBox,
                    marginBottom: "20px",
                    fontSize: "12px",
                  }}
                >
                  <i
                    className="fa fa-exclamation-triangle"
                    style={{ marginRight: "8px" }}
                  ></i>
                  One-time password sent to your email occasionally takes longer
                  to receive depending on email server rules.
                </div>
                <div style={styles.modalFooter}>
                  <button
                    type="button"
                    style={styles.btnPrimary}
                    onClick={handleSentOtp}
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    style={styles.btnSecondary}
                    onClick={() => setShowOtpModal(false)}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Modal>

        {/* Withdraw Options Modal */}
        <Modal
          show={showWithdrawOptionModal}
          backdrop="static"
          keyboard={false}
          centered
        >
          <div style={styles.modalOverlay}>
            <div style={styles.modalHeader}>
              <div style={{ ...styles.cardHeaderIcon, ...styles.iconBlue }}>
                <i className="fa fa-arrow-circle-up"></i>
              </div>
              <div style={styles.modalTitle}>
                {isEscrowWithdraw ? "Withdraw Escrow Funds" : "Withdraw your crypto"}
              </div>
            </div>
            <div style={styles.modalBody}>
              <div
                style={styles.withdrawOption}
                onClick={() => {
                  if (isEscrowWithdraw) {
                    setShowWithdrawOptionModal(false);
                    setEscrowWithdrawTerms(false);
                    setEscrowBrandAmount("");
                    setEscrowBrandAmountError("");
                    if (homeCurrencyId) {
                      getFeesByCurrencyId({
                        currencyId: homeCurrencyId,
                        merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
                      })
                        .then((res) => {
                          const d = res.data[0];
                          setMinFee(d.MIN_FEE);
                          setFromFee(d.FROMFEE);
                          setToFee(d.TOFEE);
                          setFeeRate(d.FEE_RATE);
                          setCurrencyPrecision(d.CURRENCY_PRECISION);
                          setEscrowWithdrawStep("brand");
                        })
                        .catch(() => {
                          setEscrowWithdrawStep("brand");
                        });
                    } else {
                      setEscrowWithdrawStep("brand");
                    }
                  } else {
                    balenceTranfertoPaybitoModal(selectedAssetForWithdraw);
                  }
                }}
              >
                <i
                  className="fa fa-wallet"
                  style={{ marginRight: "10px", color: "var(--btn-color)" }}
                ></i>
                Transfer to {localStorage.getItem(SITENAMEALIAS + "_exchange")}{" "}
                Wallet
                {isEscrowWithdraw && (
                  <div style={{ fontSize: "11px", opacity: 0.5, fontWeight: "400", marginTop: "4px" }}>
                    Goes to {homeCurrency} wallet in exchange when withdrawn
                  </div>
                )}
              </div>
              {!isEscrowWithdraw && (
                <>
                  <div style={styles.withdrawDivider}>or</div>
                  <div
                    style={styles.withdrawOption}
                    onClick={getHcxXrpOtherWalletValue}
                  >
                    <i
                      className="fa fa-external-link-alt"
                      style={{ marginRight: "10px", color: "#8b5cf6" }}
                    ></i>
                    Transfer to an External Wallet
                  </div>
                </>
              )}
              {!isEscrowWithdraw && (
                <>
                  <div style={styles.withdrawDivider}>or</div>
                  <div
                    style={styles.withdrawOption}
                    onClick={handleInitiateWithdrawToBankAccount}
                  >
                    <i
                      className="fa fa-university"
                      style={{ marginRight: "10px", color: "#10b981" }}
                    ></i>
                    Withdraw to Bank Account
                  </div>
                </>
              )}
              <div
                style={{
                  ...styles.modalFooter,
                  justifyContent: "center",
                  marginTop: "24px",
                }}
              >
                <button
                  style={styles.btnSecondary}
                  onClick={() => {
                    setShowWithdrawOptionModal(false);
                    setIsEscrowWithdraw(false);
                    setEscrowWithdrawContractNo("");
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Modal>

        {/* Network Select Modal */}
        <Modal
          show={showNetworkPopup}
          backdrop="static"
          keyboard={false}
          centered
        >
          <div style={styles.modalOverlay}>
            <div style={styles.modalHeader}>
              <div style={{ ...styles.cardHeaderIcon, ...styles.iconPurple }}>
                <i className="fa fa-network-wired"></i>
              </div>
              <div style={styles.modalTitle}>Select Network</div>
            </div>
            <div style={styles.modalBody}>
              {selectedAssetNetworkList.map((iter) => (
                <div
                  key={iter}
                  style={styles.networkOption}
                  onClick={() => {
                    setSelectedNetworkForTransfer(iter);
                    setShowNetworkPopup(false);
                    setShowWithdrawOptionModal(true);
                  }}
                >
                  {cryptoNameForTransfer} {iter}
                </div>
              ))}
              <div
                style={{
                  ...styles.modalFooter,
                  justifyContent: "flex-end",
                  marginTop: "16px",
                }}
              >
                <button
                  style={styles.btnSecondary}
                  onClick={() => setShowNetworkPopup(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Modal>

        {/* Google Auth Security Modal (Login) */}
        <Modal
          show={showPaybitoSecurityAuthModal}
          backdrop="static"
          keyboard={false}
          centered
        >
          <div style={styles.modalOverlay}>
            <div style={styles.modalHeader}>
              <div style={{ ...styles.cardHeaderIcon, ...styles.iconAmber }}>
                <i className="fa fa-shield-alt"></i>
              </div>
              <div style={styles.modalTitle}>Security Authentication</div>
            </div>
            <div style={styles.modalBody}>
              <form onSubmit={(e) => e.preventDefault()}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Google Authenticator Code</label>
                  <input
                    type="number"
                    style={styles.input}
                    ref={paybitoGoogleAuthOtpInputRef}
                    onChange={(e) => {
                      if (e.target.value != "" && !isNaN(e.target.value)) {
                        setPaybitoGoogleAuthOtpRefState(e.target.value);
                        setIsButtonDisable(false);
                      } else {
                        setIsButtonDisable(true);
                      }
                    }}
                    placeholder="Two-Factor Authenticator code"
                  />
                </div>
                <div style={styles.modalFooter}>
                  <button
                    type="button"
                    style={{
                      ...styles.btnPrimary,
                      opacity: isButtonDisable ? 0.5 : 1,
                    }}
                    onClick={paybitoGoogleAuthLogin}
                    disabled={isButtonDisable}
                  >
                    Confirm
                  </button>
                  <button
                    type="button"
                    style={styles.btnSecondary}
                    onClick={() => {
                      setShowPaybitoSecurityAuthModal(false);
                      setShowPaybitoOtpModal(true);
                      setPaybitoGoogleAuthOtpRefState("");
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Modal>

        {/* External Wallet Transfer Modal */}
        <Modal
          show={showExternalAddressModal}
          backdrop="static"
          keyboard={false}
          centered
        >
          <div style={styles.modalOverlay}>
            <div style={styles.modalHeader}>
              <div style={{ ...styles.cardHeaderIcon, ...styles.iconPurple }}>
                <i className="fa fa-external-link-alt"></i>
              </div>
              <div>
                <div style={styles.modalTitle}>
                  Transfer{" "}
                  {transferCurrencyName == "USDT TRC"
                    ? "USDT"
                    : transferCurrencyName}
                  {selectedNetworkForTransfer != null
                    ? ` ${selectedNetworkForTransfer}`
                    : ""}{" "}
                  to External Wallet
                </div>
              </div>
            </div>
            <div style={styles.modalBody}>
              <div style={styles.formGroup}>
                <div style={styles.radioGroup}>
                  <label style={styles.radioLabel}>
                    <input
                      type="radio"
                      name="addressEntryMode"
                      value="manual"
                      checked={addressEntryMode === "manual"}
                      onChange={handleManualEntryMode}
                    />
                    New Address
                  </label>
                  <label style={styles.radioLabel}>
                    <input
                      type="radio"
                      name="addressEntryMode"
                      value="saved"
                      checked={addressEntryMode === "saved"}
                      onChange={handleSavedEntryMode}
                    />
                    Select Saved Address
                  </label>
                </div>

                {addressEntryMode === "saved" && (
                  <div style={{ marginTop: "12px" }}>
                    <select
                      style={styles.select}
                      value={externalAddress}
                      onChange={handleSavedAddressSelect}
                    >
                      <option value="">Select a saved address</option>
                      {savedBitcoinAddresses?.length !== 0 &&
                      savedBitcoinAddresses[0]?.bitcoin_address ? (
                        savedBitcoinAddresses.map((addr, idx) => (
                          <option key={idx} value={addr?.bitcoin_address}>
                            {addr?.bitcoin_address}
                          </option>
                        ))
                      ) : (
                        <option value="add-new">➕ Add Crypto Address</option>
                      )}
                    </select>
                  </div>
                )}
              </div>

              {addressEntryMode === "manual" && (
                <div style={styles.formGroup}>
                  <label style={styles.label}>External Address</label>
                  <input
                    type="text"
                    style={styles.input}
                    placeholder="Enter External Address"
                    value={externalAddress}
                    onChange={isAddressValid}
                  />
                  {isValidCryptoMsg && (
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: "600",
                        marginTop: "4px",
                        color:
                          classForValidCrypto === "text-success"
                            ? "#10b981"
                            : "#ef4444",
                      }}
                    >
                      {isValidCryptoMsg}
                    </div>
                  )}
                </div>
              )}

              {coinIdForTag == "8" && (
                <div style={styles.formGroup}>
                  <label style={styles.label}>HCX Tag</label>
                  <input
                    type="text"
                    style={styles.input}
                    placeholder="Enter tag"
                    value={coinTagValue}
                    onChange={(e) => {
                      const sanitized = e.target.value
                        .replace(/[^a-zA-Z0-9]/g, "")
                        .slice(0, 30);
                      setCoinTagValue(sanitized);
                    }}
                  />
                </div>
              )}

              {coinIdForTag == "14" && (
                <div style={styles.formGroup}>
                  <label style={styles.label}>XRP Tag</label>
                  <input
                    type="text"
                    style={styles.input}
                    placeholder="Enter tag"
                    value={coinTagValue}
                    onChange={(e) => {
                      const sanitized = e.target.value
                        .replace(/[^a-zA-Z0-9]/g, "")
                        .slice(0, 30);
                      setCoinTagValue(sanitized);
                    }}
                  />
                </div>
              )}

              {coinIdForTag != "" &&
                handleDynamicCurrencyDetiails(assets, coinIdForTag)
                  .isBrokerCurrency == 1 &&
                handleDynamicCurrencyDetiails(assets, coinIdForTag)
                  .network[0] == "HCNET" && (
                  <div style={styles.formGroup}>
                    <label style={styles.label}>
                      {
                        handleDynamicCurrencyDetiails(assets, coinIdForTag)
                          .assetCode
                      }{" "}
                      Tag
                    </label>
                    <input
                      type="text"
                      style={styles.input}
                      placeholder="Enter Tag"
                      value={coinTagValue}
                      onChange={(e) => {
                        const sanitized = e.target.value
                          .replace(/[^a-zA-Z0-9]/g, "")
                          .slice(0, 30);
                        setCoinTagValue(sanitized);
                      }}
                    />
                  </div>
                )}
              <div style={styles.formGroup}>
                <label style={styles.label}>Amount</label>
                <div
                  style={{ display: "flex", gap: "10px", alignItems: "center" }}
                >
                  <input
                    type="number"
                    min={0}
                    style={{ ...styles.input, flex: 1 }}
                    placeholder="Enter Amount"
                    ref={externalAddressTransferAmount}
                    value={amountForTransferToExternalAddress}
                    onChange={(e) => {
                      const value = e.target.value;
                      const maxAmount = parseFloat(toFee);
                      const minAmount = parseFloat(fromFee);

                      if (value === "") {
                        setAmountForTransferToExternalAddress(value);
                        setAmountError("");
                        return;
                      }

                      const numericValue = parseFloat(value);
                      let error = "";
                      if (
                        !isNaN(numericValue) &&
                        maxAmount &&
                        numericValue > maxAmount
                      ) {
                        error = `Maximum amount is ${toFee}`;
                      }

                      if (
                        !isNaN(numericValue) &&
                        minAmount &&
                        numericValue < minAmount
                      ) {
                        error = `Minimum amount is ${fromFee}`;
                      }

                      setAmountForTransferToExternalAddress(value);
                      setAmountError(error);
                    }}
                    onKeyUp={rate}
                  />
                  <button
                    style={{ ...styles.btnOutline, whiteSpace: "nowrap" }}
                    onClick={maxSendAmount}
                    disabled={isButtonDisable}
                  >
                    Max
                  </button>
                </div>
                {amountError && (
                  <div
                    style={{ color: "red", fontSize: "12px", marginTop: "5px" }}
                  >
                    {amountError}
                  </div>
                )}
              </div>
              <div style={{ marginTop: "20px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "10px 0",
                    borderBottom: "1px solid var(--body-color-less2)",
                    fontSize: "13px",
                  }}
                >
                  <span style={{ opacity: 0.6 }}>Estimated Network Fee</span>
                  <span style={{ ...styles.balanceText, fontSize: "13px" }}>
                    {networkFee || "—"}
                  </span>
                </div>
              </div>
              <div
                style={{
                  ...styles.infoBox,
                  marginTop: "14px",
                  fontSize: "12px",
                }}
              >
                <div>
                  Minimum of {fromFee} and Maximum {toFee} can be sent.
                </div>
              </div>
              <div
                style={{
                  ...styles.warningBox,
                  marginTop: "10px",
                  fontSize: "12px",
                }}
              >
                <i
                  className="fa fa-exclamation-triangle"
                  style={{ marginRight: "8px" }}
                ></i>
                For the safety of your assets, please make sure the transfer
                network is{" "}
                <b>
                  {selectedNetworkForTransfer != null &&
                  selectedNetworkForTransfer != ""
                    ? selectedNetworkForTransfer
                    : transferCurrencyName}
                </b>
                . If the network does not match, your assets will be lost.
              </div>
              <div
                style={{
                  ...styles.modalFooter,
                  justifyContent: "center",
                  marginTop: "24px",
                }}
              >
                <button
                  style={{
                    ...styles.btnPrimary,
                    opacity: isDisabled ? 0.5 : 1,
                  }}
                  onClick={handleTranferToExternalAddress}
                  disabled={isDisabled}
                >
                  Transfer
                </button>
                <button
                  style={styles.btnSecondary}
                  onClick={() => {
                    setShowExternalAddressModal(false);
                    setShowLoader(true);
                    handleRenderLedgerAmount();
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Modal>

        {/* Security Auth for Paybito Wallet Transfer */}
        <Modal
          show={showPaybitoSecurityAuthTranscationModal}
          backdrop="static"
          keyboard={false}
          centered
        >
          <div style={styles.modalOverlay}>
            <div style={styles.modalHeader}>
              <div style={{ ...styles.cardHeaderIcon, ...styles.iconAmber }}>
                <i className="fa fa-lock"></i>
              </div>
              <div style={styles.modalTitle}>Security Authentication</div>
            </div>
            <div style={styles.modalBody}>
              <form onSubmit={(e) => e.preventDefault()}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>
                    6-Digit Google Authenticator Code
                  </label>
                  <input
                    type="number"
                    style={styles.input}
                    ref={paybitoGoogleAuthTranscationOtpRefInput}
                    onChange={(e) => setIsConfirmBtn(e.target.value == "")}
                    onKeyUp={(e) => {
                      let elmVal = e.target.value;
                      let regex = /^[0-9]{6,6}$/;
                      if (regex.test(elmVal)) {
                        setIsConfirmBtn(false);
                      } else {
                        setIsConfirmBtn(true);
                        if (
                          paybitoGoogleAuthTranscationOtpRefInput.current
                            ?.value > 999999
                        ) {
                          paybitoGoogleAuthTranscationOtpRefInput.current.value =
                            "";
                        }
                      }
                    }}
                    placeholder="Two-Factor Authenticator code"
                  />
                </div>
                <div style={styles.modalFooter}>
                  <button
                    type="button"
                    style={{
                      ...styles.btnPrimary,
                      opacity: isConfirmBtn ? 0.5 : 1,
                    }}
                    onClick={transferToPaybitoWallet}
                    disabled={isConfirmBtn}
                  >
                    Confirm
                  </button>
                  <button
                    type="button"
                    style={styles.btnSecondary}
                    onClick={() => {
                      if (isEscrowBrandTransfer) {
                        setEscrowWithdrawStep("brand");
                      } else {
                        setTransferModal(true);
                      }
                      if (paybitoGoogleAuthTranscationOtpRefInput.current) {
                        paybitoGoogleAuthTranscationOtpRefInput.current.value =
                          "";
                      }
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Modal>

        {/* Paybito Wallet Transfer Security Modal */}
        <Modal
          show={paybitoAuthModal}
          backdrop="static"
          keyboard={false}
          centered
          onShow={() => {
            if (!isTimerStartForPaybitoGetCode) {
              sendVerificationMail();
            }
          }}
        >
          <div style={styles.modalOverlay}>
            <div style={styles.modalHeader}>
              <div style={{ ...styles.cardHeaderIcon, ...styles.iconAmber }}>
                <i className="fa fa-user-shield"></i>
              </div>
              <div style={styles.modalTitle}>Security Authentication</div>
            </div>
            <div style={styles.modalBody}>
              <form onSubmit={(e) => e.preventDefault()}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Email OTP</label>
                  <div style={{ position: "relative" }}>
                    <input
                      type="number"
                      style={{ ...styles.input, paddingRight: "80px" }}
                      ref={paybitoEmailOtpRef}
                      value={paybitoEmailOtp}
                      onChange={(e) => {
                        setPaybitoEmailOtp(e.target.value);
                        setIsButtonDisable(!isButtonDisable);
                      }}
                      onKeyUp={(e) => {
                        let elmVal = e.target.value;
                        let regex = /^[0-9]{8,8}$/;
                        if (regex.test(elmVal)) {
                          setIsExternalTransferSecurityBtn(false);
                        } else {
                          setIsExternalTransferSecurityBtn(true);
                          if (paybitoEmailOtp > 9999999) {
                            setPaybitoEmailOtp("");
                          }
                        }
                      }}
                      placeholder="Enter OTP"
                    />
                    {!isTimerStartForPaybitoGetCode && (
                      <span
                        style={styles.getCodeBtn}
                        onClick={sendVerificationMail}
                      >
                        Get Code
                      </span>
                    )}
                  </div>
                  {isTimerStartForPaybitoGetCode && (
                    <div style={styles.timerText}>
                      OTP Sent - Resend OTP in {timer}
                    </div>
                  )}
                </div>

                {isPhoneValidationOn && (
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Phone OTP</label>
                    <div style={{ position: "relative" }}>
                      <input
                        type="number"
                        style={{ ...styles.input, paddingRight: "80px" }}
                        placeholder="OTP from registered phone no"
                        ref={smsOtpRef}
                        value={smsAuthOtp}
                        onChange={(e) => {
                          setSmsAuthOtp(e.target.value);
                          setIsExternalTransferSecurityBtn(
                            !isExternalTransferSecurityBtn
                          );
                        }}
                        onKeyUp={(e) => {
                          let elmVal = e.target.value;
                          let regex = /^[0-9]{8,8}$/;
                          if (regex.test(elmVal)) {
                            setIsExternalTransferSecurityBtn(false);
                          } else {
                            setIsExternalTransferSecurityBtn(true);
                            if (smsAuthOtp > 9999999) {
                              setSmsAuthOtp("");
                            }
                          }
                        }}
                      />
                      {!isTimerStartForSmsGetCode && (
                        <span
                          style={styles.getCodeBtn}
                          onClick={handleMobileOtp}
                        >
                          Get Code
                        </span>
                      )}
                    </div>
                    {isTimerStartForSmsGetCode && (
                      <div style={styles.timerText}>
                        Resend OTP in {getCodeSmsTimer}
                      </div>
                    )}
                  </div>
                )}

                {isTwoFactorAuthOn && (
                  <div style={styles.formGroup}>
                    <label style={styles.label}>
                      Google Authenticator Code
                    </label>
                    <input
                      type="number"
                      style={styles.input}
                      placeholder="Google Authentication code"
                      ref={paybitoGoogleAuthOtpInputRef}
                      value={paybitoGoogleAuthOtp}
                      onChange={(e) => {
                        setPaybitoGoogleAuthOtp(e.target.value);
                        setIsExternalTransferSecurityBtn(
                          !isExternalTransferSecurityBtn
                        );
                      }}
                      onKeyUp={(e) => {
                        let elmVal = e.target.value;
                        let regex = /^[0-9]{6,6}$/;
                        if (regex.test(elmVal)) {
                          setIsExternalTransferSecurityBtn(false);
                        } else {
                          setIsExternalTransferSecurityBtn(true);
                          if (paybitoGoogleAuthOtp > 99999) {
                            setPaybitoGoogleAuthOtp("");
                          }
                        }
                      }}
                    />
                  </div>
                )}

                <div style={styles.modalFooter}>
                  <button
                    type="button"
                    style={{
                      ...styles.btnPrimary,
                      opacity: isExternalTransferSecurityBtn ? 0.5 : 1,
                    }}
                    onClick={paybitoUserLogin}
                    disabled={isExternalTransferSecurityBtn}
                  >
                    Confirm
                  </button>
                  <button
                    type="button"
                    style={styles.btnSecondary}
                    onClick={() => {
                      setShowAddAddressModal(true);
                      setPaybitoAuthModal(false);
                      setPaybitoEmailOtp("");
                      setSmsAuthOtp("");
                      setPaybitoGoogleAuthOtp("");
                      localStorage.setItem("smsCodeCountdownsec", "");
                      localStorage.setItem("countdownsec", "");
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Modal>

        {/* External Wallet Auth Modal */}
        <Modal
          show={showExternalWalletAuthModal}
          backdrop="static"
          keyboard={false}
          centered
          onShow={() => {
            if (!isTimerStartForExternalWalletGetCode) {
              externalWalletOtpVerificationMail();
            }
          }}
        >
          <div style={styles.modalOverlay}>
            <div style={styles.modalHeader}>
              <div style={{ ...styles.cardHeaderIcon, ...styles.iconRed }}>
                <i className="fa fa-shield-alt"></i>
              </div>
              <div style={styles.modalTitle}>Security Authentication</div>
            </div>
            <div style={styles.modalBody}>
              <form onSubmit={(e) => e.preventDefault()}>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Email OTP</label>
                  <div style={{ position: "relative" }}>
                    <input
                      type="number"
                      style={{ ...styles.input, paddingRight: "80px" }}
                      ref={transferToExternalEmailOtpRef}
                      value={externalWalletEmailAuthOtp}
                      onChange={(e) => {
                        setExternalWalletEmailAuthOtp(e.target.value);
                        setIsButtonDisable(!isButtonDisable);
                      }}
                      placeholder="Enter OTP"
                    />
                    {!isTimerStartForExternalWalletGetCode && (
                      <span
                        style={styles.getCodeBtn}
                        onClick={externalWalletOtpVerificationMail}
                      >
                        Get Code
                      </span>
                    )}
                  </div>
                  {isTimerStartForExternalWalletGetCode && (
                    <div style={styles.timerText}>
                      OTP Sent - Resend OTP in {getCodeTimer}
                    </div>
                  )}
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.label}>Google Authenticator Code</label>
                  <input
                    type="number"
                    style={styles.input}
                    placeholder="Google Authentication code"
                    ref={transferToExternalGoogleAuthCodeRef}
                    value={externalWalletGoogleAuthCode}
                    onChange={(e) => {
                      setExternalWalletGoogleAuthCode(e.target.value);
                      setIsExternalTransferSecurityBtn(
                        !isExternalTransferSecurityBtn
                      );
                    }}
                    onKeyUp={function (e) {
                      let elmVal = e.target.value;
                      let regex = /^[0-9]{6,6}$/;
                      if (regex.test(elmVal)) {
                        setIsExternalTransferSecurityBtn(false);
                      } else {
                        setIsExternalTransferSecurityBtn(true);
                      }
                    }}
                  />
                </div>
                <div style={styles.modalFooter}>
                  <button
                    type="button"
                    style={{
                      ...styles.btnPrimary,
                      opacity: isExternalTransferSecurityBtn ? 0.5 : 1,
                    }}
                    onClick={transferToExternal}
                    disabled={isExternalTransferSecurityBtn}
                  >
                    Confirm
                  </button>
                  <button
                    type="button"
                    style={styles.btnSecondary}
                    onClick={() => {
                      setShowExternalWalletAuthModal(false);
                      setShowExternalAddressModal(true);
                      setIsValidCryptoMsg("");
                      localStorage.setItem("externalWalletCountdownsec", "");
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Modal>

        {/* KYC Status Modal */}
        <Modal
          show={showKycStatusModal}
          backdrop="static"
          keyboard={false}
          centered
        >
          <div style={styles.modalOverlay}>
            <div style={styles.modalHeader}>
              <div style={{ ...styles.cardHeaderIcon, ...styles.iconGreen }}>
                <i className="fa fa-id-card"></i>
              </div>
              <div style={styles.modalTitle}>KYC Verification Required</div>
            </div>
            <div style={styles.modalBody}>
              <div style={{ textAlign: "center", padding: "32px 0" }}>
                <div
                  style={{
                    fontSize: "48px",
                    opacity: 0.2,
                    marginBottom: "16px",
                  }}
                >
                  <i className="fa fa-id-card"></i>
                </div>
                <div
                  style={{
                    fontSize: "16px",
                    fontWeight: "700",
                    color: "var(--text-color)",
                    marginBottom: "8px",
                  }}
                >
                  {userDocsStatus === null || userDocsStatus === undefined
                    ? "KYC Not Submitted"
                    : String(userDocsStatus) === "0"
                    ? "KYC Under Review"
                    : "KYC Declined"}
                </div>
                <div
                  style={{
                    fontSize: "13px",
                    opacity: 0.6,
                    marginBottom: "20px",
                  }}
                >
                  {userDocsStatus === null || userDocsStatus === undefined
                    ? "Please complete your KYC verification before initiating a bank withdrawal."
                    : String(userDocsStatus) === "0"
                    ? "Your KYC has been submitted and is awaiting admin approval."
                    : "Your KYC was declined. Please resubmit your KYC documents."}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "10px",
                  }}
                >
                  {String(userDocsStatus) !== "0" && (
                    <button
                      style={styles.btnPrimary}
                      onClick={() => {
                        setShowKycStatusModal(false);
                        history.push("/identity-verification");
                      }}
                    >
                      {userDocsStatus === null || userDocsStatus === undefined
                        ? "Submit KYC"
                        : "Resubmit KYC"}
                    </button>
                  )}
                  <button
                    style={styles.btnSecondary}
                    onClick={() => {
                      setShowKycStatusModal(false);
                      setShowWithdrawOptionModal(true);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        {/* Bank Transfer Modal */}
        <Modal
          show={showBankTransferModal}
          backdrop="static"
          keyboard={false}
          centered
        >
          <div style={styles.modalOverlay}>
            <div style={styles.modalHeader}>
              <div style={{ ...styles.cardHeaderIcon, ...styles.iconGreen }}>
                <i className="fa fa-university"></i>
              </div>
              <div style={styles.modalTitle}>Withdraw to Bank Account</div>
            </div>
            <div style={styles.modalBody}>
              {bankDetailsStatus !== "2" ? (
                <div style={{ textAlign: "center", padding: "32px 0" }}>
                  <div
                    style={{
                      fontSize: "48px",
                      opacity: 0.2,
                      marginBottom: "16px",
                    }}
                  >
                    <i className="fa fa-university"></i>
                  </div>
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "700",
                      color: "var(--text-color)",
                      marginBottom: "8px",
                    }}
                  >
                    {bankDetailsStatus === null
                      ? "No Bank Details Found"
                      : bankDetailsStatus === "0"
                      ? "Bank Details Submitted"
                      : "Bank Details Rejected"}
                  </div>
                  <div
                    style={{
                      fontSize: "13px",
                      opacity: 0.6,
                      marginBottom: "20px",
                    }}
                  >
                    {bankDetailsStatus === null
                      ? "Please submit your bank information before initiating a withdrawal."
                      : bankDetailsStatus === "0"
                      ? "Your bank details are being reviewed."
                      : "Your bank details have been rejected. Please update them."}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: "10px",
                    }}
                  >
                    <button
                      style={styles.btnPrimary}
                      onClick={() => {
                        setShowBankTransferModal(false);
                        history.push("/bank-info");
                      }}
                    >
                      {bankDetailsStatus === null
                        ? "Submit Bank Info"
                        : "Update Bank Info"}
                    </button>
                    <button
                      style={styles.btnSecondary}
                      onClick={() => {
                        setShowBankTransferModal(false);
                        setShowWithdrawOptionModal(true);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              ) : (
                <div>
                  <div style={styles.formGroup}>
                    <label style={styles.label}>
                      Crypto Amount
                      <span
                        style={{
                          opacity: 0.5,
                          textTransform: "none",
                          fontWeight: "400",
                          marginLeft: "6px",
                        }}
                      >
                        ({selectedAssetForWithdraw?.assetCode || ""})
                      </span>
                    </label>
                    <input
                      type="number"
                      min={0}
                      style={styles.input}
                      placeholder={`Enter amount in ${
                        selectedAssetForWithdraw?.assetCode || "crypto"
                      }`}
                      value={cryptoAmountForBank}
                      onChange={(e) => {
                        const value = e.target.value;

                        if (value === "") {
                          setCryptoAmountForBank("");
                          setAmountErrorBank("");
                          return;
                        }
                        setCryptoAmountForBank(value);

                        handleCryptoAmountChange(e); // 👈 call your original handler
                      }}
                    />

                    {amountErrorBank && (
                      <p style={{ color: "red", fontSize: 12 }}>
                        {amountErrorBank}
                      </p>
                    )}
                    <div
                      style={{
                        fontSize: "12px",
                        opacity: 0.5,
                        marginTop: "6px",
                      }}
                    >
                      Available Balance:{" "}
                      <span style={{ fontWeight: "700" }}>
                        {selectedAssetForWithdraw?.coinBalance ?? 0}{" "}
                        {selectedAssetForWithdraw?.assetCode || ""}
                      </span>
                    </div>
                  </div>

                  {fiatEquivalentAmount !== "" && (
                    <div style={{ ...styles.infoBox, marginBottom: "18px" }}>
                      <span style={{ fontSize: "14px" }}>
                        ≈ Equivalent {homeCurrency} Amount:{" "}
                        <b>
                          {fiatEquivalentAmount} {homeCurrency}
                        </b>
                      </span>
                    </div>
                  )}

                  <div style={styles.formGroup}>
                    <label style={styles.label}>
                      Google Authentication OTP (2FA)
                    </label>
                    <input
                      type="number"
                      min={0}
                      maxLength={6}
                      style={styles.input}
                      placeholder="Enter Google Authentication OTP (2FA)"
                      value={googleAuthOtpForBankWithdraw}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (val.length <= 6) {
                          setGoogleAuthOtpForBankWithdraw(val);
                        }
                      }}
                    />
                  </div>

                  <div
                    style={{
                      height: "1px",
                      background: "var(--body-color-less2)",
                      margin: "20px 0",
                    }}
                  ></div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginBottom: "16px",
                    }}
                  >
                    <i
                      className="fa fa-university"
                      style={{ color: "var(--btn-color)", fontSize: "14px" }}
                    ></i>
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: "700",
                        color: "var(--text-color)",
                      }}
                    >
                      Your Bank Details
                    </span>
                  </div>
                  <div
                    style={{
                      padding: "16px",
                      borderRadius: "12px",
                      background: "var(--body-color)",
                      border: "1px solid var(--body-color-less2)",
                    }}
                  >
                    <div style={styles.bankDetailRow}>
                      <div style={styles.bankDetailLabel}>Beneficiary Name</div>
                      <div style={styles.bankDetailValue}>
                        {merchantBankDetails?.benificiary_name || ""}
                      </div>
                    </div>
                    <div style={styles.bankDetailRow}>
                      <div style={styles.bankDetailLabel}>Bank Name</div>
                      <div style={styles.bankDetailValue}>
                        {merchantBankDetails?.bank_name || ""}
                      </div>
                    </div>
                    <div style={styles.bankDetailRow}>
                      <div style={styles.bankDetailLabel}>Account Number</div>
                      <div style={styles.bankDetailValue}>
                        {merchantBankDetails?.account_no || ""}
                      </div>
                    </div>
                    <div style={styles.bankDetailRow}>
                      <div style={styles.bankDetailLabel}>Account Type</div>
                      <div style={styles.bankDetailValue}>
                        {merchantBankDetails?.accountType || ""}
                      </div>
                    </div>
                    {merchantBankDetails?.ifscCode && (
                      <div style={styles.bankDetailRow}>
                        <div style={styles.bankDetailLabel}>IFSC Code</div>
                        <div style={styles.bankDetailValue}>
                          {merchantBankDetails?.ifscCode}
                        </div>
                      </div>
                    )}
                    {merchantBankDetails?.swiftCode && (
                      <div style={styles.bankDetailRow}>
                        <div style={styles.bankDetailLabel}>SWIFT Code</div>
                        <div style={styles.bankDetailValue}>
                          {merchantBankDetails?.swiftCode}
                        </div>
                      </div>
                    )}
                    {merchantBankDetails?.routing_no && (
                      <div style={styles.bankDetailRow}>
                        <div style={styles.bankDetailLabel}>Routing Number</div>
                        <div style={styles.bankDetailValue}>
                          {merchantBankDetails?.routing_no}
                        </div>
                      </div>
                    )}
                    {merchantBankDetails?.bankAddress && (
                      <div
                        style={{
                          ...styles.bankDetailRow,
                          borderBottom: "none",
                        }}
                      >
                        <div style={styles.bankDetailLabel}>Bank Address</div>
                        <div style={styles.bankDetailValue}>
                          {merchantBankDetails?.bankAddress}
                        </div>
                      </div>
                    )}
                  </div>

                  <div
                    style={{
                      ...styles.infoBox,
                      marginTop: "14px",
                      textAlign: "center",
                      fontSize: "13px",
                    }}
                  >
                    Equivalent {homeCurrency} Amount should between{" "}
                    {bankWithdrawLimit?.min || 0} {homeCurrency} &{" "}
                    {bankWithdrawLimit?.max || 0} {homeCurrency}
                  </div>

                  {/* Terms checkbox — shown only for Escrow withdrawals */}
                  {isEscrowWithdraw && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: "10px",
                        margin: "18px 0 4px",
                      }}
                    >
                      <input
                        type="checkbox"
                        id="escrow-bank-terms"
                        checked={escrowWithdrawTerms}
                        onChange={(e) => setEscrowWithdrawTerms(e.target.checked)}
                        style={{
                          marginTop: "2px",
                          accentColor: "#10b981",
                          width: "15px",
                          height: "15px",
                          flexShrink: 0,
                          cursor: "pointer",
                        }}
                      />
                      <label
                        htmlFor="escrow-bank-terms"
                        style={{
                          fontSize: "12.5px",
                          color: "var(--text-color)",
                          opacity: 0.8,
                          lineHeight: "1.55",
                          cursor: "pointer",
                        }}
                      >
                        I agree to the{" "}
                        <a
                          href="https://www.paybito.com/escrow/payee-terms"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#10b981", textDecoration: "underline" }}
                        >
                          Payee Terms
                        </a>
                        ,{" "}
                        <a
                          href="https://www.paybito.com/merchants-using-pay-services-terms-of-use/"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#10b981", textDecoration: "underline" }}
                        >
                          Merchant Terms
                        </a>{" "}
                        and{" "}
                        <a
                          href="https://www.paybito.com/exchange-fees/"
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "#10b981", textDecoration: "underline" }}
                        >
                          Fee Schedule
                        </a>
                        .
                      </label>
                    </div>
                  )}

                  <div
                    style={{
                      ...styles.modalFooter,
                      justifyContent: "center",
                      marginTop: "24px",
                    }}
                  >
                    <button
                      style={{
                        ...styles.btnPrimary,
                        opacity: (isWithdrawDisabled || (isEscrowWithdraw && !escrowWithdrawTerms)) ? 0.5 : 1,
                      }}
                      disabled={isWithdrawDisabled || (isEscrowWithdraw && !escrowWithdrawTerms)}
                      onClick={handleBankWithdraw}
                    >
                      Withdraw
                    </button>
                    <button
                      style={styles.btnSecondary}
                      onClick={() => {
                        setShowBankTransferModal(false);
                        setEscrowWithdrawTerms(false);
                        setShowWithdrawOptionModal(true);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Modal>

        {/* ── Escrow Brand Wallet Confirm Modal ── */}
        <Modal
          show={escrowWithdrawStep === "brand"}
          backdrop="static"
          keyboard={false}
          centered
        >
          <div style={styles.modalOverlay}>

            {escrowWithdrawStep === "brand" && (
              <>
                <div style={styles.modalHeader}>
                  <div style={{ ...styles.cardHeaderIcon, ...styles.iconBlue }}>
                    <i className="fa fa-wallet"></i>
                  </div>
                  <div>
                    <div style={styles.modalTitle}>Withdraw to {localStorage.getItem(SITENAMEALIAS + "_exchange")} Wallet</div>
                    <div
                      style={{
                        fontSize: "12px",
                        opacity: 0.5,
                        marginTop: "2px",
                      }}
                    >
                      Funds will go to your {homeCurrency} wallet in exchange
                    </div>
                    {escrowWithdrawContractNo && (
                      <div style={{ fontSize: "11px", marginTop: "4px", color: "#10b981", fontWeight: 600 }}>
                        Contract: {escrowWithdrawContractNo}
                      </div>
                    )}
                  </div>
                </div>
                <div style={styles.modalBody}>
                  {/* Amount input */}
                  <div style={styles.formGroup}>
                    <label style={styles.label}>Amount</label>
                    <input
                      type="number"
                      min={0}
                      step="any"
                      style={styles.input}
                      placeholder="Enter amount"
                      value={escrowBrandAmount}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (val === "") {
                          setEscrowBrandAmount("");
                          setEscrowBrandAmountError("");
                          return;
                        }
                        const num = parseFloat(val);
                        const availableBalance = parseFloat(escrowWalletBalance);
                        let err = "";
                        if (!isNaN(num) && num <= 0) {
                          err = "Amount must be greater than 0";
                        } else if (!isNaN(num) && !isNaN(availableBalance) && num > availableBalance) {
                          err = `Amount must be less than or equal to contract amount (${escrowWalletBalance} ${escrowWalletCurrency})`;
                        }
                        setEscrowBrandAmount(val);
                        setEscrowBrandAmountError(err);
                      }}
                    />
                    {escrowBrandAmountError && (
                      <p style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                        {escrowBrandAmountError}
                      </p>
                    )}
                    <div style={{ fontSize: "12px", opacity: 0.5, marginTop: "6px" }}>
                      Contract Amount:{" "}
                      <span style={{ fontWeight: "700" }}>
                        {escrowWalletBalance} {escrowWalletCurrency}
                      </span>
                    </div>
                  </div>

                  {/* Terms checkbox */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "10px",
                      margin: "0 0 24px",
                    }}
                  >
                    <input
                      type="checkbox"
                      id="escrow-brand-terms"
                      checked={escrowWithdrawTerms}
                      onChange={(e) => setEscrowWithdrawTerms(e.target.checked)}
                      style={{
                        marginTop: "2px",
                        accentColor: "#10b981",
                        width: "15px",
                        height: "15px",
                        flexShrink: 0,
                        cursor: "pointer",
                      }}
                    />
                    <label
                      htmlFor="escrow-brand-terms"
                      style={{
                        fontSize: "12.5px",
                        color: "var(--text-color)",
                        opacity: 0.8,
                        lineHeight: "1.55",
                        cursor: "pointer",
                      }}
                    >
                      I agree to the{" "}
                      <a
                        href="https://www.paybito.com/escrow/payee-terms"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#10b981", textDecoration: "underline" }}
                      >
                        Payee Terms
                      </a>
                      ,{" "}
                      <a
                        href="https://www.paybito.com/merchants-using-pay-services-terms-of-use/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#10b981", textDecoration: "underline" }}
                      >
                        Merchant Terms
                      </a>{" "}
                      and{" "}
                      <a
                        href="https://www.paybito.com/exchange-fees/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#10b981", textDecoration: "underline" }}
                      >
                        Fee Schedule
                      </a>
                      .
                    </label>
                  </div>

                  <div
                    style={{ ...styles.modalFooter, justifyContent: "center" }}
                  >
                    <button
                      style={{
                        ...styles.btnPrimary,
                        background: "#10b981",
                        opacity: (escrowWithdrawTerms && escrowBrandAmount && !escrowBrandAmountError) ? 1 : 0.45,
                      }}
                      disabled={!escrowWithdrawTerms || !escrowBrandAmount || !!escrowBrandAmountError}
                      onClick={handleEscrowBrandConfirm}
                    >
                      Confirm Withdrawal
                    </button>
                    <button
                      style={styles.btnSecondary}
                      onClick={() => {
                        setEscrowWithdrawStep(null);
                        setEscrowWithdrawTerms(false);
                        setEscrowBrandAmount("");
                        setEscrowBrandAmountError("");
                        setShowWithdrawOptionModal(true);
                      }}
                    >
                      Back
                    </button>
                  </div>
                </div>
              </>
            )}

          </div>
        </Modal>

        <PaybitoCaptchaExchange ref={paybitoRecaptchaRef} />
        <Loader show={showLoader} />
      </div>
    </Fragment>
  );
};

export default Dashboard;
